<ng-template #settingsTemplate>
    <app-tool-setting>
        <app-check-box
            [checked]="toggles.length.shown"
            (checkedChange)="toggleValue(toggles.length)"
            label="lengte"
        ></app-check-box>
        <app-check-box
            [checked]="toggles.cubicLitre.shown"
            (checkedChange)="toggleValue(toggles.cubicLitre)"
            label="inhoud (liter)"
        ></app-check-box>
        <app-check-box
            [checked]="toggles.weight.shown"
            (checkedChange)="toggleValue(toggles.weight)"
            label="gewicht"
        ></app-check-box>
    </app-tool-setting>
    <app-tool-setting>
        <app-check-box
            [checked]="toggles.surface.shown"
            (checkedChange)="toggleValue(toggles.surface)"
            label="oppervlakte"
        ></app-check-box>
        <app-check-box
            [checked]="toggles.cubicMeter.shown"
            (checkedChange)="toggleValue(toggles.cubicMeter)"
            label="inhoud (m<sup>3</sup>)"
        ></app-check-box>
    </app-tool-setting>
    <app-tool-setting>
        <app-check-box
            [checked]="showJumps"
            (checkedChange)="showJumps = !showJumps"
            label="sprongen"
        ></app-check-box>
        <app-check-box
            [checked]="toggles.cubicConnection.shown"
            (checkedChange)="toggleValue(toggles.cubicConnection)"
            label="verbinding inhoud"
        ></app-check-box>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        version="1.1"
        id="Laag_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1109.3 565.7"
        style="enable-background: new 0 0 1109.3 565.7; width: 720px"
        xml:space="preserve"
    >
        <style type="text/css">
            .st0 {
                fill: #ffffff;
            }
            .st1 {
                fill: #8ed4f1;
            }
            .st2 {
                fill: #42b7e8;
            }
            .st3 {
                fill: #0091d5;
            }
            .st4 {
                fill: #f29501;
            }
            .st5 {
                fill: #004f9f;
            }
            .st6 {
                fill: #494949;
            }
            .st7 {
                fill: #f7c067;
            }
            .st8 {
                fill: #1d1d1b;
            }
            .st9 {
                fill: none;
                stroke: #0091d5;
                stroke-width: 1.89;
            }
            .st10 {
                fill: none;
                stroke: #0091d5;
                stroke-width: 1.86;
            }
            .st11 {
                fill: none;
                stroke: #0091d5;
                stroke-width: 2;
            }
            .st12 {
                fill: #55a932;
            }
            .st13 {
                fill: #99cb84;
            }
            .st14 {
                fill: #ffffff;
                stroke: #55a932;
                stroke-width: 1.5;
                stroke-miterlimit: 10;
            }
            .st15 {
                fill: #55a932;
                stroke: #55a932;
                stroke-width: 0.5;
                stroke-miterlimit: 10;
            }
        </style>
        @if (toggles.cubicMeter.shown && toggles.cubicConnection.shown) {
        <g id="connection">
            <g>
                <polyline
                    class="st9"
                    points="500.2,78.4 500.2,96.3 669.2,96.3 669.2,117.4 		"
                />
                <path
                    class="st3"
                    d="M496.7,74.9c0-2,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5c0,2-1.6,3.5-3.5,3.5C498.3,78.4,496.7,76.9,496.7,74.9
			C496.7,74.9,496.7,74.9,496.7,74.9z"
                />
                <path
                    class="st3"
                    d="M665.7,117.4c0,2,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5c0-2-1.6-3.5-3.5-3.5C667.3,113.9,665.7,115.4,665.7,117.4
			C665.7,117.4,665.7,117.4,665.7,117.4z"
                />
                <polyline
                    class="st10"
                    points="1049.2,78.4 1049.2,96.3 885.2,96.3 885.2,117.9 		"
                />
                <path
                    class="st3"
                    d="M1045.7,74.8c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.6,3.5-3.5,3.5
			C1047.3,78.4,1045.8,76.8,1045.7,74.8C1045.7,74.9,1045.7,74.9,1045.7,74.8z"
                />
                <path
                    class="st3"
                    d="M881.7,117.4c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5c0-1.9-1.6-3.5-3.5-3.5
			C883.3,113.9,881.8,115.5,881.7,117.4C881.7,117.4,881.7,117.4,881.7,117.4z"
                />
                <line class="st11" x1="777.9" y1="78.8" x2="777.9" y2="117.4" />
                <path
                    class="st3"
                    d="M774.1,75.3c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8S774.1,77.4,774.1,75.3
			C774.1,75.3,774.1,75.3,774.1,75.3z"
                />
                <path
                    class="st3"
                    d="M774.1,117.4c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8S774.1,115.3,774.1,117.4
			L774.1,117.4z"
                />
            </g>
        </g>
        } @if (toggles.cubicConnection.shown) {
        <g
            class="system_item"
            id="verbinding_inhoud"
            data-name="verbinding inhoud"
            [ngStyle]="{
                transform:
                    'translateY(' + toggles.cubicConnection.offset + 'px)'
            }"
        >
            <g>
                <path
                    class="st0"
                    d="M565.9,74.7c-3.4,0-3.5-2.6-3.5-2.9V30.6c0-2.9,3.4-2.9,3.5-2.9h56.6c3.4,0,3.5,2.6,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9h0H565.9z"
                />
                <path
                    class="st1"
                    d="M622.5,28.2c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4h-56.6c-2.8,0-3-2-3-2.4V30.6c0-2.3,2.7-2.4,3-2.4
			H622.5 M622.5,27.2h-56.6c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h56.6c0,0,4,0,4-3.4V30.6C626.5,30.6,626.5,27.2,622.5,27.2
			L622.5,27.2z"
                />
            </g>
            <g>
                <path
                    class="st0"
                    d="M838.7,74.7c-3.4,0-3.5-2.6-3.5-2.9V30.6c0-2.9,3.4-2.9,3.5-2.9h56.6c3.4,0,3.5,2.6,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9h0H838.7z"
                />
                <path
                    class="st1"
                    d="M895.3,28.2c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4h-56.6c-2.8,0-3-2-3-2.4V30.6c0-2.3,2.7-2.4,3-2.4
			H895.3 M895.3,27.2h-56.6c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h56.6c0,0,4,0,4-3.4V30.6C899.3,30.6,899.3,27.2,895.3,27.2
			L895.3,27.2z"
                />
            </g>
            <path
                class="st1"
                d="M468.6,27.2c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4V30.6c0,0,0-3.4-3.1-3.4
		L468.6,27.2z"
            />
            <path
                class="st0"
                d="M494.8,45.4h2.4v6.8l2.5-3.4h2.7l-2.8,3.5l2.9,4.7h-2.8l-2.5-4.4V57h-2.4V45.4z"
            />
            <path class="st0" d="M503.7,45.4h2.4V57h-2.4V45.4z" />
            <g>
                <path
                    class="st0"
                    d="M656.9,74.7c-3.4,0-3.5-2.6-3.5-2.9V30.6c0-2.9,3.4-2.9,3.5-2.9h56.6c3.4,0,3.5,2.6,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9h0H656.9z"
                />
                <path
                    class="st1"
                    d="M713.5,28.2c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4h-56.6c-2.8,0-3-2-3-2.4V30.6c0-2.3,2.7-2.4,3-2.4
			H713.5 M713.5,27.2h-56.6c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h56.6c0,0,4,0,4-3.4V30.6C717.5,30.6,717.5,27.2,713.5,27.2
			L713.5,27.2z"
                />
            </g>
            <g>
                <path
                    class="st0"
                    d="M935.6,74.7c-3.4,0-3.5-2.6-3.5-2.9V30.6c0-2.9,3.4-2.9,3.5-2.9h56.6c3.4,0,3.5,2.6,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9h0H935.6z"
                />
                <path
                    class="st1"
                    d="M992.2,28.2c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4h-56.6c-2.8,0-3-2-3-2.4V30.6c0-2.3,2.7-2.4,3-2.4
			H992.2 M992.2,27.2h-56.6c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h56.6c0,0,4,0,4-3.4V30.6C996.2,30.6,996.2,27.2,992.2,27.2
			L992.2,27.2z"
                />
            </g>
            <path
                class="st2"
                d="M747,27.2c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4V30.6c0,0,0-3.4-3.1-3.4L747,27.2z
		"
            />
            <path class="st0" d="M777.7,45.4h2.4V57h-2.4V45.4z" />
            <path
                class="st2"
                d="M1019.4,27.2c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4V30.6c0,0,0-3.4-3.1-3.4
		L1019.4,27.2z"
            />
            <path
                class="st0"
                d="M1042.6,50.4c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4V57h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		V57h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8V57h-2.4V50.4z"
            />
            <path class="st0" d="M1057.7,45.4h2.4V57h-2.4V45.4z" />
            <g>
                <path
                    class="st0"
                    d="M27,74.7c-3.4,0-3.5-2.6-3.5-2.9V30.6c0-2.9,3.4-2.9,3.5-2.9h127c3.4,0,3.5,2.6,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9h0H27z"
                />
                <path
                    class="st3"
                    d="M154,28.2c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4H27c-2.8,0-3-2-3-2.4V30.6c0-2.3,2.7-2.4,3-2.4H154
			 M154,27.2H27c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h127c0,0,4,0,4-3.4V30.6C158,30.6,158,27.2,154,27.2L154,27.2z"
                />
            </g>
            <path
                class="st3"
                d="M79.8,45.4h2.5v2.1h-2.5V45.4z M79.9,48.9h2.4V57h-2.4L79.9,48.9z"
            />
            <path
                class="st3"
                d="M84.4,50.4c0,0,0-0.9,0-1.5h2.3l0.1,1.2c0.5-0.9,1.5-1.5,2.6-1.4c1.1-0.1,2.1,0.5,2.5,1.5
		c0.2,0.8,0.3,1.6,0.2,2.4V57h-2.5v-5c0-0.3,0-0.6-0.1-0.9c-0.2-0.4-0.7-0.7-1.2-0.7c-0.5,0-1,0.2-1.3,0.6c-0.2,0.4-0.3,0.8-0.3,1.2
		V57h-2.3V50.4z"
            />
            <path
                class="st3"
                d="M94.2,45.4h2.3V50c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2V57h-2.4v-4.9
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.1,0,0.2V57h-2.4V45.4z"
            />
            <path
                class="st3"
                d="M107.7,48.7c2.2-0.2,4,1.5,4.2,3.6c0,0.2,0,0.4,0,0.6c0.2,2.2-1.5,4.1-3.7,4.3c-0.2,0-0.4,0-0.6,0
		c-2.1,0.1-4-1.5-4.1-3.6c0-0.2,0-0.4,0-0.6C103.5,51,104.5,48.7,107.7,48.7z M107.7,55.6c1,0,1.7-0.6,1.7-2.8
		c0-1.1-0.2-2.6-1.8-2.6c-1.7,0-1.8,2-1.8,2.7C105.9,54.9,106.5,55.6,107.7,55.6L107.7,55.6z"
            />
            <path
                class="st3"
                d="M116,48.9v4.8c0,0.7,0,1.8,1.3,1.8c1.5,0,1.5-1.1,1.5-2.5v-4.1h2.4v5.3c0,1.7,0,2,0,2.2s0,0.4,0.1,0.6H119
		l-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.9,0-1.8-0.4-2.4-1.1c-0.4-0.7-0.6-1.4-0.5-2.2v-5L116,48.9z"
            />
            <path
                class="st3"
                d="M128.8,45.4h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4s1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1L128.8,45.4z M127,55.6c0.6,0,1.2-0.4,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C125.3,54.4,125.8,55.6,127,55.6z"
            />
            <path
                class="st3"
                d="M59.7,36.5V33l-9.4,2.6v2.9l-0.2,0.2l-4.9,2.6v23.1l9.5,5.1l9.6-5.1V40.6L59.7,36.5z M62.7,41l-7.7,2.9l-3-4.5
		l6.6-2L62.7,41z M51.6,36.6l6.8-1.9v1.4l-6.8,2V36.6z M46.5,42l4.3-2.2l3.3,4.9v22.9l-7.6-4.1L46.5,42z M63,63.5l-7.6,4.1V45.1
		l7.6-2.8V63.5z"
            />
        </g>
        } @if (toggles.cubicMeter.shown) {
        <g
            class="system_item"
            id="inhoud_m3"
            data-name="inhoud m3"
            [ngStyle]="{
                transform: 'translateY(' + toggles.cubicMeter.offset + 'px)'
            }"
        >
            <path
                class="st4"
                d="M636.4,117.4c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H636.4
		z"
            />
            <path
                class="st0"
                d="M658.9,131c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.7c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L658.9,131z"
            />
            <path
                class="st0"
                d="M674.5,130.4c0,0.4,0.3,0.8,0.7,0.9c0,0,0.1,0,0.1,0c0.5,0,0.8-0.3,0.8-0.8c0,0,0-0.1,0-0.1c0-1-0.9-1-1.6-1
		v-1.1c0.7,0,1.6,0,1.6-1c0-0.4-0.3-0.8-0.7-0.8c0,0,0,0-0.1,0c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0,0,0.1h-1.4c0-0.4,0.1-0.8,0.4-1.1
		c0.5-0.5,1.1-0.8,1.8-0.7c1.7,0,2.2,1.1,2.2,1.8c0,0.7-0.5,1.3-1.2,1.5c0.3,0.1,0.5,0.2,0.8,0.4c0.3,0.3,0.5,0.7,0.5,1.2
		c-0.1,1.2-1.1,2-2.3,1.9c0,0,0,0-0.1,0c-0.6,0-1.1-0.1-1.6-0.4c-0.4-0.4-0.6-0.9-0.6-1.5L674.5,130.4z"
            />
            <path
                class="st0"
                d="M650,145.2h2.3v6.8l2.5-3.4h2.7l-2.8,3.5l3,4.6h-2.8l-2.5-4.4v4.4H650V145.2z"
            />
            <path
                class="st0"
                d="M661.2,148.7v4.8c0,0.7,0,1.8,1.3,1.8c1.5,0,1.5-1.1,1.5-2.5v-4.1h2.4v5.3c0,1.7,0,1.9,0,2.2
		c0,0.2,0,0.4,0.1,0.6h-2.3l-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.9,0-1.8-0.4-2.4-1.1c-0.4-0.7-0.6-1.4-0.5-2.2v-5L661.2,148.7z"
            />
            <path
                class="st0"
                d="M670.9,148.7v4.8c0,0.7,0,1.8,1.3,1.8c1.5,0,1.5-1.1,1.5-2.5v-4.1h2.4v5.3c0,1.7,0,1.9,0,2.2s0,0.4,0.1,0.6
		h-2.3l-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.9,0-1.8-0.4-2.4-1.1c-0.4-0.7-0.6-1.4-0.5-2.2v-5L670.9,148.7z"
            />
            <path
                class="st0"
                d="M678.3,145.2h2.4v4.4c0.5-0.7,1.4-1.1,2.3-1.1c2,0,3.5,1.6,3.5,4.3c0,3-1.8,4.1-3.4,4.1
		c-1,0.1-1.9-0.4-2.4-1.3c0,0.2,0,0.6-0.1,1.1h-2.3V145.2z M682.3,150.1c-1.8,0-1.8,2-1.8,2.5c0,1.8,0.8,2.7,1.9,2.7
		c1.6,0,1.6-2,1.6-2.4C684.1,152.3,684,150.1,682.3,150.1L682.3,150.1z"
            />
            @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M858.2,165.3l-6.7,3.7l1.5,1.3c-5.2,4.4-11.8,6.7-18.5,6.6c-12.8,0-23.3-11.8-23.4-12l-0.8,0.7
		c0.4,0.5,11,12.3,24.2,12.3c7.1,0.1,14-2.4,19.3-7l1.7,1.5L858.2,165.3z"
                />
                <path
                    class="st5"
                    d="M834,104.8c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
		c12.8,0,23.3,11.8,23.4,11.9l0.8-0.7C857.7,116.6,847.2,104.8,834,104.8z"
                />
            </g>
            }
            <path
                class="st4"
                d="M747,117.4c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H747z"
            />
            <path
                class="st0"
                d="M770.2,135.6h2.4v10.2c0,0.4,0,0.9,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4s1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1V135.6z M768.4,145.8c0.6,0,1.2-0.3,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.4-1.8-2.4c-1.6,0-1.8,1.9-1.8,2.7C766.7,144.6,767.2,145.8,768.4,145.8z"
            />
            <path
                class="st0"
                d="M774.7,140.6c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.5,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.9h-2.4V140.6z"
            />
            <path
                class="st0"
                d="M790.3,140c0,0.4,0.3,0.8,0.7,0.9c0,0,0.1,0,0.1,0c0.5,0,0.8-0.3,0.8-0.8c0,0,0-0.1,0-0.1c0-1-0.9-1-1.6-1
		v-1.1c0.7,0,1.6,0,1.6-1c0-0.4-0.3-0.8-0.7-0.8c0,0,0,0-0.1,0c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0,0,0.1H789c0-0.4,0.1-0.8,0.4-1.1
		c0.5-0.5,1.1-0.8,1.8-0.7c1.7,0,2.2,1.1,2.2,1.8c0,0.7-0.5,1.3-1.2,1.5c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.3,0.5,0.7,0.5,1.2
		c-0.1,1.2-1.1,2-2.3,1.9c0,0,0,0-0.1,0c-0.6,0-1.1-0.1-1.6-0.4c-0.4-0.4-0.6-0.9-0.6-1.5L790.3,140z"
            />
            @if (showJumps) {
            <path
                class="st5"
                d="M748.2,165.3l-6.7,3.7l1.5,1.3c-5.2,4.4-11.8,6.7-18.5,6.6c-12.8,0-23.3-11.8-23.4-12l-0.8,0.7
		c0.4,0.5,11,12.3,24.2,12.3c7.1,0.1,14-2.4,19.3-7l1.7,1.5L748.2,165.3z"
            />
            }
            <path
                class="st4"
                d="M857.4,117.4c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H857.4
		z"
            />
            @if (showJumps) {
            <path
                class="st5"
                d="M724,104.8c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
		c12.8,0,23.3,11.8,23.4,11.9l0.8-0.7C747.7,116.6,737.2,104.8,724,104.8z"
            />
            }
            <path
                class="st0"
                d="M880.4,141.9c0-0.3-0.1-1.5-1-1.5c-1.1,0-1.2,1.7-1.2,2.6c0,0.9,0.2,1.7,0.6,2.5c0.2,0.2,0.4,0.3,0.6,0.3
		c0.2,0,1-0.1,1.1-1.6h2.3c0,0.9-0.3,1.8-1,2.4c-0.6,0.5-1.5,0.8-2.3,0.8c-1,0.1-2-0.3-2.8-1.1c-0.7-0.9-1.1-2-1-3.2
		c0-3.7,2.7-4.2,3.8-4.2c1.6-0.2,3.1,1,3.3,2.7c0,0.1,0,0.2,0,0.3L880.4,141.9z"
            />
            <path
                class="st0"
                d="M884.2,140.6c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.8-1.4,2.7-1.9,4.1-1.1c0.4,0.2,0.7,0.5,1,0.9c0.3,0.7,0.5,1.6,0.4,2.4v4.7h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8
		c-1.4,0-1.5,1.3-1.5,2.5v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.9h-2.4L884.2,140.6z"
            />
            <path
                class="st0"
                d="M899.8,140c0,0.4,0.3,0.8,0.7,0.9c0,0,0.1,0,0.1,0c0.5,0,0.8-0.3,0.8-0.8c0,0,0-0.1,0-0.1c0-1-0.9-1-1.6-1
		v-1.1c0.7,0,1.6,0,1.6-1c0-0.4-0.3-0.8-0.7-0.8c0,0,0,0-0.1,0c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0,0,0.1h-1.4c0-0.4,0.1-0.8,0.4-1.1
		c0.5-0.5,1.2-0.7,1.9-0.7c1.7,0,2.2,1.1,2.2,1.8c0,0.7-0.5,1.3-1.2,1.5c0.3,0.1,0.5,0.2,0.8,0.4c0.3,0.3,0.5,0.7,0.5,1.2
		c-0.1,1.2-1.1,2-2.3,1.9c0,0,0,0-0.1,0c-0.6,0-1.1-0.1-1.6-0.4c-0.4-0.4-0.6-0.9-0.6-1.5L899.8,140z"
            />
            @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M818,162.1l-2.4-2.4l0.7-0.7l2.4,2.4l2.4-2.4l0.8,0.7l-2.4,2.4l2.4,2.4l-0.8,0.7l-2.4-2.4l-2.4,2.4l-0.7-0.7
		L818,162.1z"
                />
                <path
                    class="st6"
                    d="M826.1,157.8c-0.6,0.5-1.3,0.9-2.1,1.3v-1.3c0.8-0.4,1.5-0.9,2.2-1.4h1.2v9h-1.2L826.1,157.8z"
                />
                <path
                    class="st6"
                    d="M832.7,156.2c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C829.6,159.7,829.8,156.2,832.7,156.2z M832.7,164.5c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.8-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C830.9,163,831.3,164.5,832.7,164.5L832.7,164.5z"
                />
                <path
                    class="st6"
                    d="M840.4,156.2c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C837.4,159.7,837.5,156.2,840.4,156.2z M840.4,164.5c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C838.6,163,839,164.5,840.4,164.5L840.4,164.5z"
                />
                <path
                    class="st6"
                    d="M817.8,118.7h1.4v1.5h-1.4V118.7z M817.8,123.8h1.4v1.5h-1.4V123.8z"
                />
                <path
                    class="st6"
                    d="M823.9,118.7c-0.6,0.5-1.3,0.9-2.1,1.3v-1.3c0.8-0.4,1.5-0.9,2.2-1.4h1.2v9h-1.2L823.9,118.7z"
                />
                <path
                    class="st6"
                    d="M830.5,117.1c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C827.5,120.6,827.6,117.1,830.5,117.1z M830.5,125.4c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C828.7,123.8,829.1,125.4,830.5,125.4L830.5,125.4z"
                />
                <path
                    class="st6"
                    d="M838.2,117.1c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C835.2,120.6,835.4,117.1,838.2,117.1z M838.2,125.4c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C836.5,123.8,836.9,125.4,838.2,125.4L838.2,125.4z"
                />
                <path
                    class="st6"
                    d="M846,117.1c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-0.5,0.4-1.1,0.7-1.8,0.7c-1,0-2-0.6-2.4-1.5
		c-0.4-1-0.6-2-0.6-3.1C842.9,120.6,843.1,117.1,846,117.1z M846,125.4c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C844.2,123.8,844.6,125.4,846,125.4L846,125.4z"
                />
                <path
                    class="st6"
                    d="M707.8,118.7h1.4v1.5h-1.4V118.7z M707.8,123.8h1.4v1.5h-1.4V123.8z"
                />
                <path
                    class="st6"
                    d="M713.9,118.7c-0.6,0.5-1.3,0.9-2.1,1.3v-1.3c0.8-0.4,1.5-0.9,2.2-1.4h1.2v9h-1.2L713.9,118.7z"
                />
                <path
                    class="st6"
                    d="M720.5,117.1c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C717.5,120.6,717.6,117.1,720.5,117.1z M720.5,125.4c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C718.7,123.8,719.1,125.4,720.5,125.4L720.5,125.4z"
                />
                <path
                    class="st6"
                    d="M728.2,117.1c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C725.2,120.6,725.4,117.1,728.2,117.1z M728.2,125.4c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C726.5,123.8,726.9,125.4,728.2,125.4L728.2,125.4z"
                />
                <path
                    class="st6"
                    d="M736,117.1c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-0.5,0.4-1.1,0.7-1.8,0.7c-1,0-2-0.6-2.4-1.5
		c-0.4-1-0.6-2-0.6-3.1C732.9,120.6,733.1,117.1,736,117.1z M736,125.4c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C734.2,123.8,734.6,125.4,736,125.4L736,125.4z"
                />
                <path
                    class="st6"
                    d="M848.1,156.2c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C845.1,159.7,845.3,156.2,848.1,156.2z M848.1,164.5c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C846.4,163,846.7,164.5,848.1,164.5L848.1,164.5z"
                />
                <path
                    class="st6"
                    d="M708,162.1l-2.4-2.4l0.7-0.7l2.4,2.4l2.4-2.4l0.8,0.7l-2.4,2.4l2.4,2.4l-0.8,0.7l-2.4-2.4l-2.4,2.4l-0.7-0.7
		L708,162.1z"
                />
                <path
                    class="st6"
                    d="M716.1,157.8c-0.6,0.5-1.3,0.9-2.1,1.3v-1.3c0.8-0.4,1.5-0.9,2.2-1.4h1.2v9h-1.2L716.1,157.8z"
                />
                <path
                    class="st6"
                    d="M722.7,156.2c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C719.6,159.7,719.8,156.2,722.7,156.2z M722.7,164.5c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.8-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C720.9,163,721.3,164.5,722.7,164.5L722.7,164.5z"
                />
                <path
                    class="st6"
                    d="M730.4,156.2c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C727.4,159.7,727.5,156.2,730.4,156.2z M730.4,164.5c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C728.6,163,729,164.5,730.4,164.5L730.4,164.5z"
                />
                <path
                    class="st6"
                    d="M738.1,156.2c2.7,0,3,2.9,3,4.6c0,2.1-0.4,3.3-1.2,4.1c-1.1,1-2.8,0.9-3.8-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.4-1-0.6-2-0.6-3.1C735.1,159.7,735.3,156.2,738.1,156.2z M738.1,164.5c1.5,0,1.8-2,1.8-3.6c0-2.2-0.4-3.7-1.7-3.7
		c-1.6,0-1.8,2.1-1.8,3.7C736.4,163,736.7,164.5,738.1,164.5L738.1,164.5z"
                />
            </g>
            }
            <g>
                <path
                    class="st0"
                    d="M27,164.9c-3.4,0-3.5-2.6-3.5-2.9v-41.1c0-2.9,3.4-2.9,3.5-2.9h127c3.4,0,3.5,2.6,3.5,2.9V162
			c0,2.9-3.4,2.9-3.5,2.9h0H27z"
                />
                <path
                    class="st3"
                    d="M154,118.5c2.8,0,3,2,3,2.4V162c0,2.3-2.7,2.4-3,2.4H27c-2.8,0-3-2-3-2.4v-41.1c0-2.3,2.7-2.4,3-2.4H154
			 M154,117.5H27c0,0-4,0-4,3.4V162c0,0,0,3.4,4,3.4h127c0,0,4,0,4-3.4v-41.1C158,120.9,158,117.5,154,117.5L154,117.5z"
                />
            </g>
            <path
                class="st3"
                d="M82.3,135.7h2.5v2.1h-2.5V135.7z M82.4,139.1h2.4v8.1h-2.4L82.4,139.1z"
            />
            <path
                class="st3"
                d="M86.9,140.6c0,0,0-0.9,0-1.5h2.3l0.1,1.2c0.5-0.9,1.5-1.5,2.6-1.4c1.1-0.1,2.1,0.5,2.5,1.5
		c0.2,0.8,0.3,1.6,0.2,2.4v4.4H92v-5c0-0.3,0-0.6-0.1-0.9c-0.2-0.4-0.7-0.7-1.2-0.7c-0.5,0-0.9,0.2-1.2,0.6
		c-0.2,0.4-0.3,0.8-0.3,1.2v4.7h-2.3V140.6z"
            />
            <path
                class="st3"
                d="M96.7,135.7H99v4.6c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2v4.9h-2.3v-4.8
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.6,1.4c0,0.1,0,0.1,0,0.2v4.9h-2.3V135.7z"
            />
            <path
                class="st3"
                d="M110.2,139c2.2-0.2,4,1.5,4.2,3.6c0,0.2,0,0.4,0,0.6c0.2,2.2-1.5,4.1-3.7,4.3c-0.2,0-0.4,0-0.6,0
		c-2.2,0.1-4-1.5-4.1-3.7c0-0.2,0-0.4,0-0.6C106,141.3,107,139,110.2,139z M110.2,145.9c1,0,1.7-0.6,1.7-2.8c0-1.1-0.2-2.6-1.8-2.6
		c-1.7,0-1.8,2-1.8,2.7C108.4,145.1,109,145.9,110.2,145.9L110.2,145.9z"
            />
            <path
                class="st3"
                d="M118.5,139.2v4.8c0,0.7,0,1.8,1.3,1.8c1.5,0,1.5-1.1,1.5-2.5v-4.1h2.4v5.3c0,1.7,0,2,0,2.2s0,0.4,0.1,0.6h-2.3
		l-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.9,0-1.8-0.4-2.4-1.1c-0.4-0.7-0.6-1.4-0.5-2.2v-5L118.5,139.2z"
            />
            <path
                class="st3"
                d="M131.3,135.7h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4s1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1V135.7z M129.5,145.9c0.6,0,1.2-0.4,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.4-1.8-2.4c-1.6,0-1.8,1.9-1.8,2.7C127.8,144.7,128.3,145.9,129.5,145.9z"
            />
            <path
                class="st3"
                d="M54.5,127.4l-12.7,4.2v19.8l12.8,4.1l12.9-4.1v-19.8L54.5,127.4z M54.5,128.9l10.7,3.5l-10.8,3.7l-10.6-3.6
		L54.5,128.9z M43.3,133.9l10.6,3.7v16.2l-10.6-3.4V133.9z M54.4,153.9h0.4l-0.2,0.1L54.4,153.9z M55.4,153.7v-16.3l10.6-3.6v16.5
		L55.4,153.7z"
            />
        </g>
        } @if (toggles.surface.shown) {
        <g
            class="system_item"
            id="oppervlakte"
            [ngStyle]="{
                transform: 'translateY(' + toggles.surface.offset + 'px)'
            }"
        >
            @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M500.3,195.6c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C524,207.4,513.5,195.6,500.3,195.6z"
                />
                <path
                    class="st5"
                    d="M387,195.6c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C410.7,207.4,400.2,195.6,387,195.6z"
                />
                <path
                    class="st5"
                    d="M612,195.6c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C635.7,207.4,625.2,195.6,612,195.6z"
                />
                <path
                    class="st5"
                    d="M723,195.6c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C746.7,207.4,736.2,195.6,723,195.6z"
                />
                <path
                    class="st5"
                    d="M832,195.6c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C855.7,207.4,845.2,195.6,832,195.6z"
                />
                <path
                    class="st5"
                    d="M944,195.6c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C967.7,207.4,957.2,195.6,944,195.6z"
                />
            </g>
            } @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M524.5,255.3l-6.7,3.7l1.5,1.3c-5.2,4.4-11.8,6.7-18.5,6.6c-12.8,0-23.3-11.8-23.4-12l-0.8,0.7
			c0.4,0.5,11,12.3,24.2,12.3c7.1,0.1,14-2.4,19.3-7l1.7,1.5L524.5,255.3z"
                />
                <path
                    class="st5"
                    d="M411.2,255.3l-6.7,3.7l1.5,1.3c-5.2,4.4-11.8,6.7-18.5,6.6c-12.8,0-23.3-11.8-23.4-12l-0.8,0.7
			c0.4,0.5,11,12.3,24.2,12.3c7.1,0.1,14-2.4,19.3-7l1.7,1.5L411.2,255.3z"
                />
                <path
                    class="st5"
                    d="M636.2,255.3l-6.7,3.7l1.5,1.3c-5.2,4.4-11.8,6.7-18.5,6.6c-12.8,0-23.3-11.8-23.4-12l-0.8,0.7
			c0.4,0.5,11,12.3,24.2,12.3c7.1,0.1,14-2.4,19.3-7l1.7,1.5L636.2,255.3z"
                />
                <path
                    class="st5"
                    d="M747.2,255.3l-6.7,3.7l1.5,1.3c-5.2,4.4-11.8,6.7-18.5,6.6c-12.8,0-23.3-11.8-23.4-12l-0.8,0.7
			c0.4,0.5,11,12.3,24.2,12.3c7.1,0.1,14-2.4,19.3-7l1.7,1.5L747.2,255.3z"
                />
                <path
                    class="st5"
                    d="M856.2,255.3l-6.7,3.7l1.5,1.3c-5.2,4.4-11.8,6.7-18.5,6.6c-12.8,0-23.3-11.8-23.4-12l-0.8,0.7
			c0.4,0.5,11,12.3,24.2,12.3c7.1,0.1,14-2.4,19.3-7l1.7,1.5L856.2,255.3z"
                />
                <path
                    class="st5"
                    d="M968.2,255.3l-6.7,3.7l1.5,1.3c-5.2,4.4-11.8,6.7-18.5,6.6c-12.8,0-23.3-11.8-23.4-12l-0.8,0.7
			c0.4,0.5,11,12.3,24.2,12.3c7.1,0.1,14-2.4,19.3-7l1.7,1.5L968.2,255.3z"
                />
            </g>
            }
            <path
                class="st4"
                d="M299.5,207.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H299.5
		z"
            />
            <path
                class="st0"
                d="M317.5,225.9h2.4v6.8l2.4-3.4h2.7l-2.8,3.5l2.9,4.6h-2.8l-2.5-4.4v4.4h-2.4V225.9z"
            />
            <path
                class="st0"
                d="M326.5,230.9c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.6,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L326.5,230.9z"
            />
            <path
                class="st0"
                d="M340.7,230.9l1.7-1.5c0.4-0.3,0.7-0.6,1-1c0.4-0.4,0.4-0.6,0.4-0.9c0-0.4-0.3-0.8-0.7-0.8c0,0-0.1,0-0.1,0
		c-0.7,0-0.8,0.8-0.8,1h-1.4c0-0.4,0.1-0.9,0.4-1.2c0.5-0.5,1.2-0.8,1.9-0.7c1.4,0,2.2,0.8,2.2,1.8c0,0.7-0.3,1.5-3.1,3.8h1.8h1.3
		v1.1h-4.6V230.9z"
            />
            <path
                class="st4"
                d="M636.4,207.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H636.4
		z"
            />
            <path
                class="st0"
                d="M658.9,230.9c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L658.9,230.9z"
            />
            <path
                class="st0"
                d="M673.1,230.9l1.7-1.5c0.4-0.3,0.7-0.6,1-1c0.4-0.4,0.5-0.6,0.5-0.9c0-0.4-0.3-0.8-0.7-0.8c0,0-0.1,0-0.1,0
		c-0.7,0-0.8,0.8-0.8,1h-1.4c0-0.4,0.1-0.9,0.4-1.2c0.5-0.5,1.2-0.8,1.8-0.7c1.4,0,2.2,0.8,2.2,1.8c0,0.7-0.3,1.5-3.1,3.8h1.8h1.3
		v1.1h-4.6L673.1,230.9z"
            />
            <path
                class="st4"
                d="M411.5,207.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H411.5
		z"
            />
            <path
                class="st0"
                d="M429.1,216.3h2.4v4.6c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2v4.9h-2.4v-4.8
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.2,0,0.2v5h-2.4L429.1,216.3z"
            />
            <path
                class="st0"
                d="M438.9,221.3c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.5-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.8-1.4,2.7-1.9,4.1-1.1c0.4,0.2,0.7,0.5,1,0.9c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8
		c-1.4,0-1.5,1.3-1.5,2.5v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4V221.3z"
            />
            <path
                class="st0"
                d="M453.1,221.3l1.7-1.5c0.4-0.3,0.7-0.6,1-1c0.4-0.4,0.5-0.6,0.5-0.9c0-0.4-0.3-0.8-0.7-0.8c0,0-0.1,0-0.1,0
		c-0.7,0-0.8,0.8-0.8,1h-1.4c0-0.4,0.1-0.9,0.4-1.2c0.5-0.5,1.2-0.8,1.9-0.7c1.4,0,2.2,0.8,2.2,1.8c0,0.7-0.3,1.5-3.1,3.8h1.8h1.3v1
		h-4.6L453.1,221.3z"
            />
            <path
                class="st0"
                d="M434.8,235.6h2.4v4.6c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2v4.9H440v-4.9
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.2,0,0.2v5h-2.4L434.8,235.6z"
            />
            <path
                class="st0"
                d="M449.4,247.1c-0.1-0.4-0.1-0.7-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.7,0.1-1.4-0.2-2-0.6
		c-0.5-0.5-0.7-1.1-0.7-1.8c0-1.1,0.7-2.1,1.7-2.5c1-0.4,2.1-0.5,3.2-0.5c0-0.4,0-0.7-0.1-1.1c-0.2-0.4-0.6-0.7-1.1-0.7
		c-0.4,0-0.7,0.2-0.9,0.5c-0.1,0.2-0.2,0.5-0.2,0.7h-2.3c0-0.7,0.3-1.5,0.9-1.9c0.7-0.5,1.6-0.7,2.5-0.6c1.1-0.1,2.1,0.3,2.9,1
		c0.4,0.6,0.6,1.3,0.6,2v3.2c0,0.7,0.1,1.3,0.2,2L449.4,247.1z M446.5,244.6c0,0.6,0.5,1.1,1.1,1.2c0,0,0,0,0.1,0
		c0.4,0,0.8-0.2,1-0.5c0.4-0.6,0.5-1.3,0.5-2C447.6,243.2,446.5,243.6,446.5,244.6L446.5,244.6z"
            />
            <path
                class="st4"
                d="M747,207.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H747z"
            />
            <path
                class="st0"
                d="M770.1,225.9h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4s1.5-4.3,3.6-4.3c0.9,0,1.8,0.4,2.3,1.1V225.9z M768.3,236.1c0.6,0,1.2-0.4,1.5-0.9c0.3-0.6,0.4-1.2,0.4-1.9
		c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C766.7,234.9,767.2,236.1,768.3,236.1z"
            />
            <path
                class="st0"
                d="M774.6,230.9c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.5-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.8-1.4,2.7-1.9,4.1-1.1c0.4,0.2,0.7,0.5,1,0.9c0.3,0.7,0.5,1.6,0.4,2.4v4.6H785v-4.8c0-0.9-0.1-1.8-1.4-1.8
		c-1.4,0-1.5,1.3-1.5,2.5v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L774.6,230.9z"
            />
            <path
                class="st0"
                d="M788.9,230.9l1.7-1.5c0.4-0.3,0.7-0.6,1-1c0.4-0.4,0.5-0.6,0.5-0.9c0-0.4-0.3-0.8-0.7-0.8c0,0-0.1,0-0.1,0
		c-0.8,0-0.8,0.8-0.8,1H789c0-0.4,0.1-0.9,0.4-1.2c0.5-0.5,1.2-0.8,1.9-0.7c1.4,0,2.2,0.8,2.2,1.8c0,0.7-0.3,1.5-3.1,3.8h1.8h1.3
		v1.1h-4.6L788.9,230.9z"
            />
            <path
                class="st7"
                d="M524.4,207.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H524.4
		z"
            />
            <path
                class="st0"
                d="M543.1,225.9h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4s1.5-4.3,3.6-4.3c0.9,0,1.8,0.4,2.3,1.1V225.9z M541.3,236.1c0.6,0,1.2-0.4,1.5-0.9c0.3-0.6,0.4-1.2,0.4-1.9
		c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C539.7,234.9,540.1,236.1,541.3,236.1z"
            />
            <path
                class="st0"
                d="M552.4,237.5c-0.1-0.4-0.1-0.7-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.7,0.1-1.5-0.2-2-0.6
		c-0.5-0.5-0.7-1.1-0.7-1.8c0-1.1,0.7-2.1,1.7-2.5c1-0.4,2.1-0.5,3.2-0.5c0-0.4,0-0.7-0.1-1.1c-0.2-0.4-0.6-0.7-1-0.7
		c-0.4,0-0.7,0.2-0.9,0.5c-0.1,0.2-0.2,0.5-0.2,0.7h-2.3c0-0.7,0.3-1.5,0.9-1.9c0.7-0.5,1.6-0.7,2.5-0.6c1.1-0.1,2.1,0.3,2.9,1
		c0.4,0.6,0.6,1.3,0.6,2v3.2c0,0.7,0.1,1.4,0.2,2L552.4,237.5z M549.5,235c0,0.6,0.5,1.1,1.1,1.1c0,0,0.1,0,0.1,0
		c0.4,0,0.7-0.2,1-0.5c0.4-0.6,0.5-1.3,0.5-2C550.6,233.6,549.5,234,549.5,235z"
            />
            <path
                class="st0"
                d="M556.5,230.9c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4V230.9z"
            />
            <path
                class="st0"
                d="M570.7,230.9l1.7-1.5c0.4-0.3,0.7-0.6,1-1c0.4-0.4,0.5-0.6,0.5-0.9c0-0.4-0.3-0.8-0.7-0.8c0,0-0.1,0-0.1,0
		c-0.7,0-0.8,0.8-0.8,1h-1.4c0-0.4,0.1-0.9,0.4-1.2c0.5-0.5,1.2-0.8,1.9-0.7c1.4,0,2.2,0.8,2.2,1.8c0,0.7-0.3,1.5-3.1,3.8h1.8h1.3
		v1.1h-4.6V230.9z"
            />
            <path
                class="st4"
                d="M857.4,207.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H857.4
		z"
            />
            <path
                class="st0"
                d="M880.4,232.3c0-0.3-0.1-1.5-1-1.5c-1.1,0-1.2,1.7-1.2,2.6c-0.1,0.9,0.2,1.7,0.6,2.5c0.2,0.2,0.4,0.3,0.6,0.3
		c0.3,0,1-0.1,1.1-1.5h2.3c0,0.9-0.3,1.8-1,2.4c-0.6,0.5-1.5,0.8-2.3,0.8c-1,0.1-2-0.3-2.8-1.1c-0.7-0.9-1.1-2-1-3.2
		c0-3.7,2.7-4.2,3.8-4.2c1.6-0.2,3.1,1,3.3,2.7c0,0.1,0,0.2,0,0.3L880.4,232.3z"
            />
            <path
                class="st0"
                d="M884.2,230.9c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.8-1.4,2.7-1.9,4.1-1.1c0.4,0.2,0.7,0.5,1,0.9c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8
		c-1.4,0-1.5,1.3-1.5,2.5v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L884.2,230.9z"
            />
            <path
                class="st0"
                d="M898.4,230.9l1.7-1.5c0.4-0.3,0.7-0.6,1-1c0.4-0.4,0.4-0.6,0.4-0.9c0-0.4-0.3-0.8-0.7-0.8c0,0-0.1,0-0.1,0
		c-0.8,0-0.8,0.8-0.8,1h-1.4c0-0.4,0.1-0.9,0.4-1.2c0.5-0.5,1.2-0.8,1.9-0.7c1.4,0,2.2,0.8,2.2,1.8c0,0.7-0.3,1.5-3.1,3.8h1.8h1.3
		v1.1h-4.6V230.9z"
            />
            <path
                class="st4"
                d="M968.5,207.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H968.5
		z"
            />
            <path
                class="st0"
                d="M983.5,230.9c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.5-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.8-1.4,2.7-1.9,4.1-1.1c0.4,0.2,0.7,0.5,1,0.9c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8
		c-1.4,0-1.5,1.3-1.5,2.5v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L983.5,230.9z"
            />
            <path
                class="st0"
                d="M998.6,230.9c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.8-1.4,2.7-1.9,4.1-1.1c0.4,0.2,0.7,0.5,1,0.9c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8
		c-1.4,0-1.5,1.3-1.5,2.5v4h-2.4v-4.8c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L998.6,230.9z"
            />
            <path
                class="st0"
                d="M1012.8,230.9l1.7-1.5c0.4-0.3,0.7-0.6,1-1c0.4-0.4,0.4-0.6,0.4-0.9c0-0.4-0.3-0.8-0.7-0.8c0,0-0.1,0-0.1,0
		c-0.8,0-0.8,0.8-0.8,1h-1.4c0-0.4,0.1-0.9,0.4-1.2c0.5-0.5,1.2-0.8,1.8-0.7c1.4,0,2.2,0.8,2.2,1.8c0,0.7-0.3,1.5-3.1,3.8h1.8h1.3
		v1.1h-4.6L1012.8,230.9z"
            />
            @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M487.2,209.7h1.7v1.8h-1.7V209.7z M487.2,215.6h1.7v1.8h-1.7V215.6z"
                />
                <path
                    class="st6"
                    d="M494.2,209.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L494.2,209.6z"
                />
                <path
                    class="st6"
                    d="M501.8,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.3-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C498.3,211.7,498.5,207.8,501.8,207.8z M501.8,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C499.7,215.5,500.2,217.3,501.8,217.3L501.8,217.3z"
                />
                <path
                    class="st6"
                    d="M510.7,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.3-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C507.3,211.7,507.4,207.8,510.7,207.8z M510.7,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C508.7,215.5,509.1,217.3,510.7,217.3z"
                />
                <path
                    class="st6"
                    d="M374,209.7h1.7v1.8H374V209.7z M374,215.6h1.7v1.8H374V215.6z"
                />
                <path
                    class="st6"
                    d="M380.9,209.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4V209.6z"
                />
                <path
                    class="st6"
                    d="M388.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.2-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C385.1,211.7,385.2,207.8,388.5,207.8z M388.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C386.5,215.5,386.9,217.3,388.5,217.3L388.5,217.3z"
                />
                <path
                    class="st6"
                    d="M397.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.3-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C394,211.7,394.2,207.8,397.5,207.8z M397.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C395.4,215.5,395.9,217.3,397.5,217.3L397.5,217.3z"
                />
                <path
                    class="st6"
                    d="M599,209.7h1.7v1.8H599V209.7z M599,215.6h1.7v1.8H599V215.6z"
                />
                <path
                    class="st6"
                    d="M605.9,209.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4V209.6z"
                />
                <path
                    class="st6"
                    d="M613.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.2-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C610.1,211.7,610.2,207.8,613.5,207.8z M613.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C611.5,215.5,611.9,217.3,613.5,217.3L613.5,217.3z"
                />
                <path
                    class="st6"
                    d="M622.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.3-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C619,211.7,619.2,207.8,622.5,207.8z M622.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C620.4,215.5,620.9,217.3,622.5,217.3L622.5,217.3z"
                />
                <path
                    class="st6"
                    d="M710,209.7h1.7v1.8H710V209.7z M710,215.6h1.7v1.8H710V215.6z"
                />
                <path
                    class="st6"
                    d="M716.9,209.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4V209.6z"
                />
                <path
                    class="st6"
                    d="M724.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.2-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C721.1,211.7,721.2,207.8,724.5,207.8z M724.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C722.5,215.5,722.9,217.3,724.5,217.3L724.5,217.3z"
                />
                <path
                    class="st6"
                    d="M733.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.3-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C730,211.7,730.2,207.8,733.5,207.8z M733.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C731.4,215.5,731.9,217.3,733.5,217.3L733.5,217.3z"
                />
                <path
                    class="st6"
                    d="M819,209.7h1.7v1.8H819V209.7z M819,215.6h1.7v1.8H819V215.6z"
                />
                <path
                    class="st6"
                    d="M825.9,209.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4V209.6z"
                />
                <path
                    class="st6"
                    d="M833.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.2-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C830.1,211.7,830.2,207.8,833.5,207.8z M833.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C831.5,215.5,831.9,217.3,833.5,217.3L833.5,217.3z"
                />
                <path
                    class="st6"
                    d="M842.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.3-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C839,211.7,839.2,207.8,842.5,207.8z M842.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C840.4,215.5,840.9,217.3,842.5,217.3L842.5,217.3z"
                />
                <path
                    class="st6"
                    d="M931,209.7h1.7v1.8H931V209.7z M931,215.6h1.7v1.8H931V215.6z"
                />
                <path
                    class="st6"
                    d="M937.9,209.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4V209.6z"
                />
                <path
                    class="st6"
                    d="M945.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.2-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C942.1,211.7,942.2,207.8,945.5,207.8z M945.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C943.5,215.5,943.9,217.3,945.5,217.3L945.5,217.3z"
                />
                <path
                    class="st6"
                    d="M954.5,207.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-0.6,0.5-1.3,0.8-2.1,0.8c-1.2,0-2.3-0.7-2.8-1.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C951,211.7,951.2,207.8,954.5,207.8z M954.5,217.3c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C952.4,215.5,952.9,217.3,954.5,217.3L954.5,217.3z"
                />
            </g>
            } @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M487.3,251.7l-2.8-2.8l0.9-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L487.3,251.7z"
                />
                <path
                    class="st6"
                    d="M496.7,246.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L496.7,246.7z"
                />
                <path
                    class="st6"
                    d="M504.3,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C500.8,248.9,501,244.9,504.3,244.9z M504.3,254.4c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2,2.4-2,4.2C502.2,252.7,502.7,254.5,504.3,254.4L504.3,254.4z"
                />
                <path
                    class="st6"
                    d="M513.2,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C509.7,248.9,509.9,244.9,513.2,244.9z M513.2,254.4c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2,2.4-2,4.2C511.2,252.7,511.6,254.5,513.2,254.4L513.2,254.4z"
                />
                <path
                    class="st6"
                    d="M374.1,251.7l-2.8-2.8l0.9-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L374.1,251.7z"
                />
                <path
                    class="st6"
                    d="M383.4,246.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L383.4,246.7z"
                />
                <path
                    class="st6"
                    d="M391,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C387.5,248.9,387.7,244.9,391,244.9z M391,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C389,252.7,389.4,254.5,391,254.4L391,254.4z"
                />
                <path
                    class="st6"
                    d="M400,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C396.5,248.9,396.7,244.9,400,244.9z M400,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C397.9,252.7,398.4,254.5,400,254.4L400,254.4z"
                />
                <path
                    class="st6"
                    d="M599.1,251.7l-2.8-2.8l0.9-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L599.1,251.7z"
                />
                <path
                    class="st6"
                    d="M608.4,246.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L608.4,246.7z"
                />
                <path
                    class="st6"
                    d="M616,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C612.5,248.9,612.7,244.9,616,244.9z M616,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C614,252.7,614.4,254.5,616,254.4L616,254.4z"
                />
                <path
                    class="st6"
                    d="M625,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C621.5,248.9,621.7,244.9,625,244.9z M625,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C622.9,252.7,623.4,254.5,625,254.4L625,254.4z"
                />
                <path
                    class="st6"
                    d="M710.1,251.7l-2.8-2.8l0.8-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L710.1,251.7z"
                />
                <path
                    class="st6"
                    d="M719.4,246.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L719.4,246.7z"
                />
                <path
                    class="st6"
                    d="M727,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C723.5,248.9,723.7,244.9,727,244.9z M727,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C725,252.7,725.4,254.5,727,254.4L727,254.4z"
                />
                <path
                    class="st6"
                    d="M736,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C732.5,248.9,732.7,244.9,736,244.9z M736,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C733.9,252.7,734.4,254.5,736,254.4L736,254.4z"
                />
                <path
                    class="st6"
                    d="M819.1,251.7l-2.8-2.8l0.8-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L819.1,251.7z"
                />
                <path
                    class="st6"
                    d="M828.4,246.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L828.4,246.7z"
                />
                <path
                    class="st6"
                    d="M836,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C832.5,248.9,832.7,244.9,836,244.9z M836,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C834,252.7,834.4,254.5,836,254.4L836,254.4z"
                />
                <path
                    class="st6"
                    d="M845,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C841.5,248.9,841.7,244.9,845,244.9z M845,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C842.9,252.7,843.4,254.5,845,254.4L845,254.4z"
                />
                <path
                    class="st6"
                    d="M931.1,251.7l-2.8-2.8l0.8-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L931.1,251.7z"
                />
                <path
                    class="st6"
                    d="M940.4,246.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L940.4,246.7z"
                />
                <path
                    class="st6"
                    d="M948,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C944.5,248.9,944.7,244.9,948,244.9z M948,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C946,252.7,946.4,254.5,948,254.4L948,254.4z"
                />
                <path
                    class="st6"
                    d="M957,244.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.5C953.5,248.9,953.7,244.9,957,244.9z M957,254.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2.1,2.4-2.1,4.2C954.9,252.7,955.4,254.5,957,254.4L957,254.4z"
                />
            </g>
            }
            <g>
                <path
                    class="st0"
                    d="M27,255.3c-3.4,0-3.5-2.6-3.5-2.9v-41.1c0-2.9,3.4-2.9,3.5-2.9h127c3.4,0,3.5,2.6,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9H27z"
                />
                <path
                    class="st3"
                    d="M154,208.8c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4H27c-2.8,0-3-2-3-2.4v-41.1c0-2.3,2.7-2.4,3-2.4H154
			 M154,207.8H27c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h127c0,0,4,0,4-3.4v-41.1C158,211.3,158,207.8,154,207.8L154,207.8z"
                />
            </g>
            <path
                class="st3"
                d="M63.7,229.3c2.2-0.2,4,1.4,4.2,3.6c0,0.2,0,0.4,0,0.6c0.2,2.2-1.5,4.1-3.7,4.3c-0.2,0-0.4,0-0.6,0
		c-2.2,0.1-4-1.5-4.1-3.7c0-0.2,0-0.4,0-0.5C59.5,231.7,60.5,229.3,63.7,229.3z M63.7,236.2c1,0,1.7-0.6,1.7-2.8
		c0-1.1-0.2-2.6-1.8-2.6c-1.7,0-1.8,2-1.8,2.7C61.9,235.4,62.5,236.2,63.7,236.2L63.7,236.2z"
            />
            <path
                class="st3"
                d="M71.8,229.5l0.1,1.1c0.5-0.9,1.5-1.4,2.5-1.3c2.1,0,3.4,1.6,3.4,4c0,2.3-1.2,4.3-3.5,4.3
		c-0.9,0.1-1.7-0.3-2.2-1v4h-2.5v-11.1H71.8z M75.3,233.5c0-1-0.2-2.6-1.6-2.6c-0.8,0-1.9,0.6-1.9,2.8c0,0.5,0,2.5,1.8,2.5
		C74.7,236.1,75.3,235.1,75.3,233.5L75.3,233.5z"
            />
            <path
                class="st3"
                d="M81.6,229.5l0.1,1.1c0.5-0.9,1.5-1.4,2.5-1.3c2.1,0,3.4,1.6,3.4,4c0,2.3-1.2,4.3-3.5,4.3
		c-0.9,0.1-1.7-0.3-2.2-1v4h-2.4v-11.1H81.6z M85.1,233.5c0-1-0.2-2.6-1.6-2.6c-0.8,0-1.9,0.6-1.9,2.8c0,0.5,0,2.5,1.8,2.5
		C84.5,236.1,85.1,235.1,85.1,233.5L85.1,233.5z"
            />
            <path
                class="st3"
                d="M91.1,234.1c0,0.5,0,2.2,1.7,2.2c0.7,0,1.3-0.4,1.4-1.1h2.2c0,0.7-0.3,1.3-0.8,1.8c-0.8,0.7-1.8,1-2.8,0.9
		c-1,0.1-2.1-0.3-2.8-1c-1.6-2.2-1.3-5.2,0.6-7c0.7-0.5,1.5-0.7,2.3-0.7c1.4,0,2.7,0.7,3.3,2c0.4,0.9,0.6,2,0.5,3L91.1,234.1z
		 M94.1,232.7c0-0.4,0-1.8-1.4-1.8c-1,0-1.5,0.9-1.5,1.8H94.1z"
            />
            <path
                class="st3"
                d="M98.1,231.5c0-0.4-0.1-1.5-0.1-2h2.2v1.6c0.4-1.2,1.6-1.8,2.8-1.6v2.1c-2.4-0.2-2.6,1-2.6,2v4h-2.4V231.5z"
            />
            <path
                class="st3"
                d="M105.9,229.5l1.8,5.5l1.9-5.5h2.3l-2.9,8.1h-2.6l-3-8.1H105.9z"
            />
            <path class="st3" d="M113.2,226h2.4v11.6h-2.4V226z" />
            <path
                class="st3"
                d="M122.5,237.6c-0.1-0.4-0.1-0.7-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.7,0.1-1.5-0.2-2-0.6
		c-0.5-0.5-0.7-1.1-0.7-1.8c0-1.1,0.7-2.1,1.7-2.5c1-0.4,2.1-0.5,3.2-0.5c0-0.4,0-0.7-0.1-1.1c-0.2-0.4-0.6-0.7-1-0.7
		c-0.4,0-0.7,0.2-0.9,0.5c-0.1,0.2-0.2,0.5-0.2,0.7h-2.3c0-0.7,0.3-1.5,0.9-1.9c0.7-0.5,1.6-0.7,2.4-0.6c1.1-0.1,2.1,0.3,2.9,1
		c0.4,0.6,0.6,1.3,0.6,2v3.2c0,0.7,0.1,1.4,0.2,2L122.5,237.6z M119.6,235.1c0,0.6,0.4,1.1,1,1.1c0,0,0.1,0,0.1,0
		c0.4,0,0.7-0.2,1-0.5c0.4-0.6,0.5-1.3,0.4-2C120.7,233.7,119.6,234.1,119.6,235.1z"
            />
            <path
                class="st3"
                d="M126.6,226h2.3v6.8l2.4-3.4h2.6l-2.8,3.5l3,4.6h-2.8l-2.5-4.4v4.4h-2.3L126.6,226z"
            />
            <path
                class="st3"
                d="M140.2,237.5c-0.6,0.2-1.2,0.2-1.8,0.2c-2.4,0-2.4-1.5-2.4-2.2v-4.4h-1.6v-1.6h1.6V228l2.4-0.9v2.4h1.9v1.6
		h-1.9v3.6c0,0.7,0,1.2,1.1,1.2c0.3,0,0.5,0,0.8,0L140.2,237.5z"
            />
            <path
                class="st3"
                d="M143.3,234.1c0,0.5,0,2.2,1.6,2.2c0.7,0.1,1.3-0.4,1.4-1.1h2.2c0,0.7-0.3,1.3-0.8,1.8c-0.8,0.7-1.8,1-2.8,0.9
		c-1,0.1-2.1-0.3-2.9-1c-1.6-2.2-1.3-5.2,0.6-7c0.7-0.4,1.5-0.7,2.3-0.7c1.4,0,2.7,0.7,3.3,2c0.4,0.9,0.6,2,0.5,3L143.3,234.1z
		 M146.3,232.7c0-0.4,0-1.8-1.4-1.8c-1,0-1.5,0.9-1.5,1.8H146.3z"
            />
            <path
                class="st3"
                d="M54.2,241.8h-20v-20h20V241.8z M35.7,240.3h17v-17h-17V240.3z"
            />
        </g>
        } @if (toggles.length.shown) {
        <g
            class="system_item"
            id="lengte"
            [ngStyle]="{
                transform: 'translateY(' + toggles.length.offset + 'px)'
            }"
        >
            @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M387,285.8c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C410.7,297.6,400.2,285.8,387,285.8z"
                />
                <path
                    class="st5"
                    d="M500,285.8c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.7,0,23.3,11.8,23.4,12l0.8-0.7C523.7,297.6,513.2,285.8,500,285.8z"
                />
                <path
                    class="st5"
                    d="M611,285.8c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C634.7,297.6,624.2,285.8,611,285.8z"
                />
                <path
                    class="st5"
                    d="M724,285.8c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C747.7,297.6,737.2,285.8,724,285.8z"
                />
                <path
                    class="st5"
                    d="M834,285.8c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C857.7,297.6,847.2,285.8,834,285.8z"
                />
                <path
                    class="st5"
                    d="M945,285.8c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C968.7,297.6,958.2,285.8,945,285.8z"
                />
            </g>
            } @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M411.2,345.2l-6.7,3.6l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L411.2,345.2z"
                />
                <path
                    class="st5"
                    d="M524.2,345.2l-6.7,3.6l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L524.2,345.2z"
                />
                <path
                    class="st5"
                    d="M635.2,345.2l-6.7,3.6l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L635.2,345.2z"
                />
                <path
                    class="st5"
                    d="M748.2,345.2l-6.7,3.6l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L748.2,345.2z"
                />
                <path
                    class="st5"
                    d="M858.2,345.2l-6.7,3.6l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L858.2,345.2z"
                />
                <path
                    class="st5"
                    d="M969.2,345.2l-6.7,3.6l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L969.2,345.2z"
                />
            </g>
            }
            <path
                class="st4"
                d="M299.5,298.1c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H299.5
		z"
            />
            <path
                class="st0"
                d="M320.6,316.3h2.4v6.8l2.4-3.4h2.7l-2.8,3.5l3,4.6h-2.8l-2.5-4.4v4.4h-2.4L320.6,316.3z"
            />
            <path
                class="st0"
                d="M329.5,321.3c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.4,1.3-1.4,2.5
		v4h-2.4V323c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L329.5,321.3z"
            />
            <g>
                <path
                    class="st4"
                    d="M636.4,345.2c-2.1,0-2.2-2.1-2.2-2.5v-41.1c0-2.4,1.9-2.5,2.2-2.5h63.8c2.1,0,2.2,2.1,2.2,2.5v41.1
			c0,2.5-2,2.5-2.2,2.5H636.4z"
                />
                <path
                    class="st8"
                    d="M700.1,299.9c1.1,0,1.3,1.1,1.3,1.7v41.1c0,1.1-0.5,1.6-1.3,1.7h-63.8c-1.2,0-1.3-1.1-1.4-1.7v-41.1
			c0-1.1,0.5-1.6,1.4-1.7H700.1 M700.1,298.1h-63.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1
			C703.2,301.6,703.2,298.1,700.1,298.1L700.1,298.1z"
                />
            </g>
            <path
                class="st0"
                d="M661.9,321.3c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4V323c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L661.9,321.3z"
            />
            <path
                class="st4"
                d="M411.5,298.1c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H411.5
		z"
            />
            <path
                class="st0"
                d="M432.1,316.3h2.4v4.5c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2v4.9h-2.4V323
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.2,0,0.2v4.9h-2.4L432.1,316.3z"
            />
            <path
                class="st0"
                d="M441.9,321.3c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4V323c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L441.9,321.3z"
            />
            <path
                class="st4"
                d="M747,298.1c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H747z"
            />
            <path
                class="st0"
                d="M773.2,316.3h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4c0-2.7,1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1V316.3z M771.4,326.5c0.6,0,1.2-0.4,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C769.7,325.3,770.2,326.5,771.4,326.5z"
            />
            <path
                class="st0"
                d="M777.6,321.3c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6H788v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5v4
		h-2.4V323c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L777.6,321.3z"
            />
            <path
                class="st7"
                d="M524.4,298.1c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H524.4
		z"
            />
            <path
                class="st0"
                d="M546.1,316.3h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4c0-2.7,1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1V316.3z M544.3,326.5c0.6,0,1.2-0.4,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C542.7,325.3,543.1,326.5,544.3,326.5z"
            />
            <path
                class="st0"
                d="M555.4,327.9c-0.1-0.4-0.1-0.7-0.1-1.1c-1,1.4-3,1.7-4.4,0.7c0,0-0.1,0-0.1-0.1c-0.5-0.5-0.7-1.1-0.7-1.8
		c0-1.1,0.7-2.1,1.7-2.5c1-0.4,2.1-0.5,3.2-0.5c0-0.4,0-0.7-0.1-1.1c-0.2-0.6-0.9-0.9-1.5-0.6c-0.2,0.1-0.4,0.2-0.5,0.4
		c-0.1,0.2-0.2,0.5-0.2,0.7h-2.3c0-0.7,0.3-1.5,0.9-1.9c0.7-0.5,1.6-0.7,2.5-0.7c1.1-0.1,2.1,0.3,2.9,1c0.4,0.6,0.6,1.3,0.6,2v3.2
		c0,0.7,0.1,1.3,0.2,2L555.4,327.9z M552.5,325.4c0,0.6,0.5,1.1,1.1,1.1c0,0,0,0,0.1,0c0.4,0,0.7-0.2,1-0.5c0.4-0.6,0.5-1.3,0.5-2
		C553.6,323.9,552.5,324.4,552.5,325.4L552.5,325.4z"
            />
            <path
                class="st0"
                d="M559.5,321.3c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.8-1.4,2.7-1.9,4.1-1.1c0.4,0.2,0.7,0.5,1,0.9c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8
		c-1.4,0-1.5,1.3-1.5,2.5v4h-2.4V323c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L559.5,321.3z"
            />
            <path
                class="st4"
                d="M857.4,298.1c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H857.4
		z"
            />
            <path
                class="st0"
                d="M883.4,322.7c0-0.3-0.1-1.5-1-1.5c-1.1,0-1.2,1.7-1.2,2.6c0,0.9,0.2,1.7,0.6,2.5c0.2,0.2,0.4,0.3,0.6,0.3
		c0.3,0,1-0.1,1.1-1.5h2.3c0,0.9-0.3,1.8-1,2.4c-0.6,0.5-1.5,0.8-2.3,0.8c-1,0.1-2-0.3-2.8-1.1c-0.7-0.9-1.1-2-1-3.2
		c0-3.7,2.7-4.2,3.8-4.2c1.6-0.2,3.1,1,3.3,2.7c0,0.1,0,0.2,0,0.3L883.4,322.7z"
            />
            <path
                class="st0"
                d="M887.2,321.3c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4V323c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L887.2,321.3z"
            />
            <path
                class="st4"
                d="M968.5,298.1c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H968.5
		z"
            />
            <path
                class="st0"
                d="M986.5,321.3c0-0.5,0-1-0.1-1.5h2.3l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4V323c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L986.5,321.3z"
            />
            <path
                class="st0"
                d="M1001.6,321.3c0-0.5,0-1-0.1-1.5h2.2l0.1,1c0.6-0.8,1.5-1.3,2.5-1.2c1.1-0.1,2.1,0.5,2.5,1.5
		c0.5-1,1.5-1.6,2.6-1.5c1-0.1,2,0.4,2.5,1.3c0.3,0.7,0.5,1.6,0.4,2.4v4.6h-2.4v-4.8c0-0.9-0.1-1.8-1.4-1.8c-1.4,0-1.5,1.3-1.5,2.5
		v4h-2.4V323c0-0.6,0-1.8-1.3-1.8c-1.5,0-1.5,1.3-1.5,1.8v4.8h-2.4L1001.6,321.3z"
            />
            @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M378.4,300.1h1.7v1.7h-1.7V300.1z M378.4,305.9h1.7v1.8h-1.7V305.9z"
                />
                <path
                    class="st6"
                    d="M385.4,300c-0.7,0.6-1.6,1.1-2.4,1.5V300c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L385.4,300z"
                />
                <path
                    class="st6"
                    d="M393,298.1c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C389.5,302.1,389.7,298.1,393,298.1z M393,307.7c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C391,305.9,391.4,307.7,393,307.7L393,307.7z"
                />
                <path
                    class="st6"
                    d="M491.4,300.1h1.7v1.7h-1.7V300.1z M491.4,305.9h1.7v1.8h-1.7V305.9z"
                />
                <path
                    class="st6"
                    d="M498.4,300c-0.7,0.6-1.6,1.1-2.4,1.5V300c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L498.4,300z"
                />
                <path
                    class="st6"
                    d="M506,298.1c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C502.5,302.1,502.7,298.1,506,298.1z M506,307.7c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C504,305.9,504.4,307.7,506,307.7L506,307.7z"
                />
                <path
                    class="st6"
                    d="M602.4,300.1h1.7v1.7h-1.7V300.1z M602.4,305.9h1.7v1.8h-1.7V305.9z"
                />
                <path
                    class="st6"
                    d="M609.4,300c-0.7,0.6-1.6,1.1-2.4,1.5V300c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L609.4,300z"
                />
                <path
                    class="st6"
                    d="M617,298.1c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C613.5,302.1,613.7,298.1,617,298.1z M617,307.7c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C615,305.9,615.4,307.7,617,307.7L617,307.7z"
                />
                <path
                    class="st6"
                    d="M715.4,300.1h1.7v1.7h-1.7V300.1z M715.4,305.9h1.7v1.8h-1.7V305.9z"
                />
                <path
                    class="st6"
                    d="M722.4,300c-0.7,0.6-1.6,1.1-2.4,1.5V300c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L722.4,300z"
                />
                <path
                    class="st6"
                    d="M730,298.1c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C726.5,302.1,726.7,298.1,730,298.1z M730,307.7c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C728,305.9,728.4,307.7,730,307.7L730,307.7z"
                />
                <path
                    class="st6"
                    d="M825.4,300.1h1.7v1.7h-1.7V300.1z M825.4,305.9h1.7v1.8h-1.7V305.9z"
                />
                <path
                    class="st6"
                    d="M832.4,300c-0.7,0.6-1.6,1.1-2.4,1.5V300c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L832.4,300z"
                />
                <path
                    class="st6"
                    d="M840,298.1c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C836.5,302.1,836.7,298.1,840,298.1z M840,307.7c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C838,305.9,838.4,307.7,840,307.7L840,307.7z"
                />
                <path
                    class="st6"
                    d="M936.4,300.1h1.7v1.7h-1.7V300.1z M936.4,305.9h1.7v1.8h-1.7V305.9z"
                />
                <path
                    class="st6"
                    d="M943.4,300c-0.7,0.6-1.6,1.1-2.4,1.5V300c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L943.4,300z"
                />
                <path
                    class="st6"
                    d="M951,298.1c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C947.5,302.1,947.7,298.1,951,298.1z M951,307.7c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C949,305.9,949.4,307.7,951,307.7L951,307.7z"
                />
            </g>
            } @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M378.6,342.1l-2.8-2.8l0.9-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L378.6,342.1z"
                />
                <path
                    class="st6"
                    d="M387.9,337.1c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L387.9,337.1z"
                />
                <path
                    class="st6"
                    d="M395.5,335.2c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C392,339.2,392.2,335.2,395.5,335.2z M395.5,344.8c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C393.4,343,393.9,344.8,395.5,344.8L395.5,344.8z"
                />
                <path
                    class="st6"
                    d="M491.6,342.1l-2.8-2.8l0.9-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L491.6,342.1z"
                />
                <path
                    class="st6"
                    d="M500.9,337.1c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L500.9,337.1z"
                />
                <path
                    class="st6"
                    d="M508.5,335.2c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C505,339.2,505.2,335.2,508.5,335.2z M508.5,344.8c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C506.4,343,506.9,344.8,508.5,344.8L508.5,344.8z"
                />
                <path
                    class="st6"
                    d="M602.6,342.1l-2.8-2.8l0.9-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L602.6,342.1z"
                />
                <path
                    class="st6"
                    d="M611.9,337.1c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4V337.1z"
                />
                <path
                    class="st6"
                    d="M619.5,335.2c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C616,339.2,616.2,335.2,619.5,335.2z M619.5,344.8c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C617.4,343,617.9,344.8,619.5,344.8L619.5,344.8z"
                />
                <path
                    class="st6"
                    d="M715.6,342.1l-2.8-2.8l0.8-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L715.6,342.1z"
                />
                <path
                    class="st6"
                    d="M724.9,337.1c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L724.9,337.1z"
                />
                <path
                    class="st6"
                    d="M732.5,335.2c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C729,339.2,729.2,335.2,732.5,335.2z M732.5,344.8c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C730.4,343,730.9,344.8,732.5,344.8L732.5,344.8z"
                />
                <path
                    class="st6"
                    d="M825.6,342.1l-2.8-2.8l0.8-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L825.6,342.1z"
                />
                <path
                    class="st6"
                    d="M834.9,337.1c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L834.9,337.1z"
                />
                <path
                    class="st6"
                    d="M842.5,335.2c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C839,339.2,839.2,335.2,842.5,335.2z M842.5,344.8c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C840.4,343,840.9,344.8,842.5,344.8L842.5,344.8z"
                />
                <path
                    class="st6"
                    d="M936.6,342.1l-2.8-2.8l0.8-0.9l2.8,2.8l2.8-2.8l0.9,0.9l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L936.6,342.1z"
                />
                <path
                    class="st6"
                    d="M945.9,337.1c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L945.9,337.1z"
                />
                <path
                    class="st6"
                    d="M953.5,335.2c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C950,339.2,950.2,335.2,953.5,335.2z M953.5,344.8c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C951.4,343,951.9,344.8,953.5,344.8L953.5,344.8z"
                />
            </g>
            }
            <g>
                <path
                    class="st0"
                    d="M27.2,345.6c-3.5,0-3.5-2.8-3.5-2.9v-41.1c0-2.9,3.4-2.9,3.5-2.9h127c3.4,0,3.5,2.6,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9h0H27.2z"
                />
                <path
                    class="st3"
                    d="M154.2,299.2c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4h-127c-2.8,0-3-2-3-2.4v-41.1c0-2.3,2.7-2.4,3-2.4
			H154.2 M154.2,298.2h-127c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h127c0,0,4,0,4-3.4v-41.1C158.2,301.6,158.2,298.2,154.2,298.2
			L154.2,298.2z"
                />
            </g>
            <path class="st3" d="M77.4,316.4h2.4v11.5h-2.4V316.4z" />
            <path
                class="st3"
                d="M83.7,324.5c0,0.5,0,2.2,1.6,2.2c0.7,0.1,1.3-0.4,1.4-1.1H89c0,0.7-0.3,1.3-0.8,1.8c-0.8,0.7-1.8,1-2.8,1
		c-1,0.1-2.1-0.3-2.8-1c-1.6-2.2-1.3-5.2,0.6-7c0.7-0.4,1.5-0.7,2.3-0.7c1.4-0.1,2.7,0.7,3.3,2c0.4,0.9,0.6,2,0.5,3L83.7,324.5z
		 M86.7,323c0-0.4,0-1.8-1.4-1.8c-1,0-1.5,0.9-1.5,1.8H86.7z"
            />
            <path
                class="st3"
                d="M90.8,321.3c0,0,0-0.9,0-1.5H93l0.1,1.2c0.5-0.9,1.6-1.5,2.6-1.4c1.1-0.1,2.1,0.5,2.5,1.5
		c0.2,0.8,0.3,1.6,0.2,2.4v4.4h-2.5v-5c0-0.3,0-0.6-0.1-0.9c-0.2-0.4-0.7-0.7-1.2-0.7c-0.5,0-0.9,0.2-1.2,0.6
		c-0.2,0.4-0.3,0.8-0.3,1.2v4.7h-2.4V321.3z"
            />
            <path
                class="st3"
                d="M108.2,319.9c-0.1,0.7-0.1,1.3-0.1,2v6c0,3-2.5,3.3-4,3.3c-1.2,0-3.4-0.1-3.6-2.6h2.3c0,0.2,0.2,1.1,1.4,1.1
		c0.7,0.1,1.3-0.4,1.5-1.1c0.1-0.6,0.1-1.3,0.1-1.9c-0.5,0.7-1.3,1.1-2.2,1.1c-2.3,0-3.4-2-3.4-4s1.1-4,3.5-4
		c0.9-0.1,1.8,0.4,2.2,1.1l0.1-1.1L108.2,319.9z M104.1,326.2c1.7,0,1.7-2,1.7-2.3c0-0.9-0.2-2.5-1.6-2.5c-0.9,0-1.6,0.7-1.6,2.4
		C102.5,324.2,102.5,326.2,104.1,326.2L104.1,326.2z"
            />
            <path
                class="st3"
                d="M115,327.9c-0.6,0.2-1.2,0.3-1.8,0.3c-2.4,0-2.4-1.5-2.4-2.2v-4.4h-1.6v-1.6h1.6v-1.6l2.3-0.9v2.5h1.9v1.6
		h-1.9v3.6c0,0.7,0,1.2,1.1,1.2c0.3,0,0.5,0,0.8,0L115,327.9z"
            />
            <path
                class="st3"
                d="M118.1,324.5c0,0.5,0,2.2,1.7,2.2c0.7,0.1,1.3-0.4,1.4-1.1h2.2c0,0.7-0.3,1.3-0.8,1.8c-0.8,0.7-1.8,1-2.8,1
		c-1,0.1-2.1-0.3-2.8-1c-0.7-0.9-1.1-2-1-3.1c-0.1-1.5,0.5-2.9,1.7-3.8c0.7-0.4,1.5-0.7,2.3-0.7c1.4-0.1,2.7,0.7,3.3,2
		c0.4,0.9,0.6,2,0.5,3L118.1,324.5z M121.1,323c0-0.4,0-1.8-1.4-1.8c-1,0-1.5,0.9-1.5,1.8H121.1z"
            />
            <path
                class="st3"
                d="M65.4,314.7l-1,0.9l-2.9-3.2l1-0.9L65.4,314.7z M62.6,315.2l-1,0.9l-1.9-2.2l1-0.9L62.6,315.2z M60.8,316.9
		l-1,0.9l-1.9-2.1l1-0.9L60.8,316.9z M59.1,318.5l-1,0.9l-1.9-2.1l1-0.9L59.1,318.5z M57.3,320.1l-1,0.9l-1.9-2.1l1-0.9L57.3,320.1z
		 M56.4,322.8l-1,0.9l-2.9-3.2l1-0.9L56.4,322.8z M53.7,323.3l-1,0.9l-1.9-2.1l1-0.9L53.7,323.3z M51.9,324.9l-1,0.9l-1.9-2.1l1-0.9
		L51.9,324.9z M50.1,326.6l-1,0.9l-1.9-2.1l1-0.9L50.1,326.6z M48.3,328.2l-1,0.9l-1.9-2.1l1-0.9L48.3,328.2z M47.4,330.8l-1,0.9
		l-2.9-3.2l1-0.9L47.4,330.8z M62.1,310.2l-19.8,17.9c-0.3,0.3-0.4,0.8-0.1,1.1c0,0,0,0,0,0l4.4,4.9c0.3,0.3,0.8,0.4,1.1,0.1
		c0,0,0,0,0,0l19.8-17.8c0.3-0.3,0.4-0.8,0.1-1.1c0,0,0,0,0,0l-4.4-4.9C63,310,62.5,309.9,62.1,310.2
		C62.2,310.2,62.1,310.2,62.1,310.2"
            />
        </g>
        } @if (toggles.cubicLitre.shown) {
        <g
            class="system_item"
            id="inhoud_l"
            data-name="inhoud l"
            [ngStyle]="{
                transform: 'translateY(' + toggles.cubicLitre.offset + 'px)'
            }"
        >
            <g>
                <path
                    class="st2"
                    d="M636.4,435.3c-2.1,0-2.2-2.1-2.2-2.5v-41.1c0-2.4,1.9-2.5,2.2-2.5h63.8c2.2,0,2.2,2.3,2.2,2.5v41.1
			c0,2.4-1.9,2.5-2.2,2.5H636.4z"
                />
                <path
                    class="st8"
                    d="M700.1,390c1.1,0,1.3,1.1,1.3,1.7v41.1c0,1.1-0.5,1.6-1.3,1.7h-63.8c-1.2,0-1.3-1.1-1.4-1.7v-41.1
			c0-1.1,0.5-1.6,1.4-1.7H700.1 M700.1,388.3h-63.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1
			C703.2,391.7,703.2,388.3,700.1,388.3L700.1,388.3z"
                />
            </g>
            <path class="st0" d="M667.1,406.4h2.4V418h-2.4V406.4z" />
            <path
                class="st1"
                d="M411.5,388.3c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H411.5
		z"
            />
            <path
                class="st0"
                d="M437.4,406.5h2.4v4.6c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2v4.9h-2.4v-4.8
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.2,0,0.2v4.9h-2.4V406.5z"
            />
            <path class="st0" d="M447.1,406.4h2.4V418h-2.4V406.4z" />
            <path
                class="st1"
                d="M299.5,388.3c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H299.5
		z"
            />
            <path
                class="st0"
                d="M325.7,406.4h2.4v6.8l2.4-3.4h2.7l-2.8,3.5l2.9,4.6h-2.8l-2.5-4.4v4.4h-2.3V406.4z"
            />
            <path class="st0" d="M334.7,406.4h2.4V418h-2.4V406.4z" />
            <path
                class="st2"
                d="M747,388.3c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H747z"
            />
            @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M387,376c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,11.9l0.8-0.7C410.7,387.8,400.2,376,387,376z"
                />
                <path
                    class="st5"
                    d="M500,376c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.7,0,23.3,11.8,23.4,11.9l0.8-0.7C523.7,387.8,513.2,376,500,376z"
                />
                <path
                    class="st5"
                    d="M611,376c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,11.9l0.8-0.7C634.7,387.8,624.2,376,611,376z"
                />
                <path
                    class="st5"
                    d="M724,376c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,11.9l0.8-0.7C747.7,387.8,737.2,376,724,376z"
                />
                <path
                    class="st5"
                    d="M834,376c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,11.9l0.8-0.7C857.7,387.8,847.2,376,834,376z"
                />
                <path
                    class="st5"
                    d="M945,376c-7.1-0.1-14,2.4-19.3,7l-1.7-1.5l-2.8,7.1l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,11.9l0.8-0.7C968.7,387.8,958.2,376,945,376z"
                />
            </g>
            } @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M411.2,435.2l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L411.2,435.2z"
                />
                <path
                    class="st5"
                    d="M524.2,435.2l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L524.2,435.2z"
                />
                <path
                    class="st5"
                    d="M635.2,435.2l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L635.2,435.2z"
                />
                <path
                    class="st5"
                    d="M748.2,435.2l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L748.2,435.2z"
                />
                <path
                    class="st5"
                    d="M858.2,435.2l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L858.2,435.2z"
                />
                <path
                    class="st5"
                    d="M969.2,435.2l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L969.2,435.2z"
                />
            </g>
            }
            <path
                class="st0"
                d="M778.4,406.4h2.3v9.8c0,0.5,0,1,0.1,1.3h-2.3l-0.1-1.1c-0.2,0.4-0.4,0.7-0.8,0.9c-0.4,0.3-1,0.4-1.5,0.4
		c-2.1,0-3.3-1.4-3.3-3.8s1.4-4.2,3.4-4.2c0.9-0.1,1.7,0.3,2.2,1.1L778.4,406.4z M776.7,416.1c0.6,0,1.2-0.3,1.4-0.9
		c0.3-0.6,0.4-1.2,0.4-1.8c0-1.5-0.7-2.3-1.7-2.3c-1.5,0-1.7,1.8-1.7,2.6C775.1,415,775.5,416.1,776.7,416.1L776.7,416.1z"
            />
            <path class="st0" d="M782.7,406.4h2.3v11.1h-2.3V406.4z" />
            <path
                class="st1"
                d="M524.4,388.3c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H524.4
		z"
            />
            <path
                class="st0"
                d="M551.3,406.5h2.4v10.3c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4s1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1L551.3,406.5z M549.5,416.6c0.6,0,1.2-0.4,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C547.9,415.4,548.4,416.6,549.5,416.6z"
            />
            <path
                class="st0"
                d="M560.6,418c-0.1-0.4-0.1-0.7-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.7,0.1-1.4-0.2-2-0.6
		c-0.5-0.5-0.7-1.1-0.7-1.8c0-1.1,0.7-2.1,1.7-2.5c1-0.3,2.1-0.5,3.2-0.4c0-0.4,0-0.7-0.1-1.1c-0.3-0.6-0.9-0.8-1.5-0.6
		c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.5-0.2,0.7h-2.4c0-0.7,0.3-1.5,0.9-1.9c0.7-0.5,1.6-0.7,2.5-0.7c1.1-0.1,2.1,0.3,2.9,1
		c0.4,0.6,0.6,1.3,0.6,2v3.2c0,0.7,0.1,1.3,0.2,2L560.6,418z M557.7,415.5c0,0.6,0.5,1.1,1.1,1.2c0,0,0.1,0,0.1,0
		c0.4,0,0.7-0.2,1-0.5c0.4-0.6,0.5-1.3,0.4-2C558.8,414.1,557.7,414.6,557.7,415.5L557.7,415.5z"
            />
            <path class="st0" d="M564.7,406.4h2.4V418h-2.4V406.4z" />
            <path
                class="st2"
                d="M857.4,388.3c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H857.4
		z"
            />
            <path
                class="st0"
                d="M888.7,412.5c0-0.3-0.1-1.4-1-1.4c-1.1,0-1.2,1.6-1.2,2.5c0,0.8,0.2,1.7,0.6,2.4c0.2,0.2,0.4,0.3,0.6,0.3
		c0.2,0,1-0.1,1-1.5h2.2c0,0.9-0.3,1.7-1,2.3c-0.6,0.5-1.4,0.8-2.2,0.7c-1,0.1-2-0.3-2.6-1c-0.7-0.8-1-1.9-1-3c0-3.5,2.6-4,3.6-4
		c1.6-0.1,3,1,3.1,2.6c0,0.1,0,0.2,0,0.3L888.7,412.5z"
            />
            <path class="st0" d="M892.2,406.4h2.3v11.1h-2.3V406.4z" />
            <path
                class="st2"
                d="M968.5,388.3c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H968.5
		z"
            />
            <path
                class="st0"
                d="M992.1,411.2c0-0.5,0-1-0.1-1.5h2.2l0.1,1c0.5-0.8,1.4-1.2,2.4-1.2c1-0.1,2,0.5,2.4,1.5
		c0.8-1.4,2.5-1.8,3.9-1.1c0.4,0.2,0.7,0.5,0.9,0.9c0.3,0.7,0.5,1.5,0.4,2.3v4.4h-2.3v-4.5c0-0.8-0.1-1.7-1.3-1.7
		c-1.4,0-1.4,1.3-1.4,2.4v3.9h-2.3v-4.6c0-0.6,0-1.7-1.3-1.7c-1.4,0-1.4,1.2-1.4,1.7v4.5h-2.3L992.1,411.2z"
            />
            <path class="st0" d="M1006.5,406.4h2.2v11.1h-2.3L1006.5,406.4z" />
            @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M378.4,390.3h1.7v1.7h-1.7V390.3z M378.4,396.2h1.7v1.8h-1.7V396.2z"
                />
                <path
                    class="st6"
                    d="M385.4,390.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L385.4,390.2z"
                />
                <path
                    class="st6"
                    d="M393,388.3c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C389.5,392.3,389.7,388.3,393,388.3z M393,397.9c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C391,396.1,391.4,397.9,393,397.9L393,397.9z"
                />
                <path
                    class="st6"
                    d="M491.4,390.3h1.7v1.7h-1.7V390.3z M491.4,396.2h1.7v1.8h-1.7V396.2z"
                />
                <path
                    class="st6"
                    d="M498.4,390.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L498.4,390.2z"
                />
                <path
                    class="st6"
                    d="M506,388.3c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C502.5,392.3,502.7,388.3,506,388.3z M506,397.9c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C504,396.1,504.4,397.9,506,397.9L506,397.9z"
                />
                <path
                    class="st6"
                    d="M602.4,390.3h1.7v1.7h-1.7V390.3z M602.4,396.2h1.7v1.8h-1.7V396.2z"
                />
                <path
                    class="st6"
                    d="M609.4,390.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L609.4,390.2z"
                />
                <path
                    class="st6"
                    d="M617,388.3c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C613.5,392.3,613.7,388.3,617,388.3z M617,397.9c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C615,396.1,615.4,397.9,617,397.9L617,397.9z"
                />
                <path
                    class="st6"
                    d="M715.4,390.3h1.7v1.7h-1.7V390.3z M715.4,396.2h1.7v1.8h-1.7V396.2z"
                />
                <path
                    class="st6"
                    d="M722.4,390.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L722.4,390.2z"
                />
                <path
                    class="st6"
                    d="M730,388.3c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C726.5,392.3,726.7,388.3,730,388.3z M730,397.9c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C728,396.1,728.4,397.9,730,397.9L730,397.9z"
                />
                <path
                    class="st6"
                    d="M825.4,390.3h1.7v1.7h-1.7V390.3z M825.4,396.2h1.7v1.8h-1.7V396.2z"
                />
                <path
                    class="st6"
                    d="M832.4,390.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L832.4,390.2z"
                />
                <path
                    class="st6"
                    d="M840,388.3c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C836.5,392.3,836.7,388.3,840,388.3z M840,397.9c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C838,396.1,838.4,397.9,840,397.9L840,397.9z"
                />
                <path
                    class="st6"
                    d="M936.4,390.3h1.7v1.7h-1.7V390.3z M936.4,396.2h1.7v1.8h-1.7V396.2z"
                />
                <path
                    class="st6"
                    d="M943.4,390.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L943.4,390.2z"
                />
                <path
                    class="st6"
                    d="M951,388.3c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C947.5,392.3,947.7,388.3,951,388.3z M951,397.9c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C949,396.1,949.4,397.9,951,397.9L951,397.9z"
                />
            </g>
            } @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M378.6,432.2l-2.8-2.8l0.9-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L378.6,432.2z"
                />
                <path
                    class="st6"
                    d="M387.9,427.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3V436h-1.4L387.9,427.2z"
                />
                <path
                    class="st6"
                    d="M395.5,425.4c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C392,429.4,392.2,425.4,395.5,425.4z M395.5,434.9c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C393.4,433.1,393.9,435,395.5,434.9L395.5,434.9z"
                />
                <path
                    class="st6"
                    d="M491.6,432.2l-2.8-2.8l0.9-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L491.6,432.2z"
                />
                <path
                    class="st6"
                    d="M500.9,427.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3V436h-1.4L500.9,427.2z"
                />
                <path
                    class="st6"
                    d="M508.5,425.4c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C505,429.4,505.2,425.4,508.5,425.4z M508.5,434.9c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C506.4,433.1,506.9,435,508.5,434.9L508.5,434.9z"
                />
                <path
                    class="st6"
                    d="M602.6,432.2l-2.8-2.8l0.9-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L602.6,432.2z"
                />
                <path
                    class="st6"
                    d="M611.9,427.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3V436h-1.4V427.2z"
                />
                <path
                    class="st6"
                    d="M619.5,425.4c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C616,429.4,616.2,425.4,619.5,425.4z M619.5,434.9c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C617.4,433.1,617.9,435,619.5,434.9L619.5,434.9z"
                />
                <path
                    class="st6"
                    d="M715.6,432.2l-2.8-2.8l0.8-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L715.6,432.2z"
                />
                <path
                    class="st6"
                    d="M724.9,427.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3V436h-1.4L724.9,427.2z"
                />
                <path
                    class="st6"
                    d="M732.5,425.4c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C729,429.4,729.2,425.4,732.5,425.4z M732.5,434.9c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C730.4,433.1,730.9,435,732.5,434.9L732.5,434.9z"
                />
                <path
                    class="st6"
                    d="M825.6,432.2l-2.8-2.8l0.8-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L825.6,432.2z"
                />
                <path
                    class="st6"
                    d="M834.9,427.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3V436h-1.4L834.9,427.2z"
                />
                <path
                    class="st6"
                    d="M842.5,425.4c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C839,429.4,839.2,425.4,842.5,425.4z M842.5,434.9c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C840.4,433.1,840.9,435,842.5,434.9L842.5,434.9z"
                />
                <path
                    class="st6"
                    d="M936.6,432.2l-2.8-2.8l0.8-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L936.6,432.2z"
                />
                <path
                    class="st6"
                    d="M945.9,427.2c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3V436h-1.4L945.9,427.2z"
                />
                <path
                    class="st6"
                    d="M953.5,425.4c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C950,429.4,950.2,425.4,953.5,425.4z M953.5,434.9c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C951.4,433.1,951.9,435,953.5,434.9L953.5,434.9z"
                />
            </g>
            }
            <g>
                <path
                    class="st0"
                    d="M27,435.8c-3.4,0-3.5-2.6-3.5-2.9v-41.1c0-2.9,3.4-2.9,3.5-2.9h127c3.5,0,3.5,2.8,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9h0H27z"
                />
                <path
                    class="st3"
                    d="M154,389.4c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4H27c-2.8,0-3-2-3-2.4v-41.1c0-2.3,2.7-2.4,3-2.4H154
			 M154,388.4H27c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h127c0,0,4,0,4-3.4v-41.1C158,391.8,158,388.4,154,388.4L154,388.4z"
                />
            </g>
            <path
                class="st3"
                d="M79.8,406.6h2.5v2.1h-2.5V406.6z M79.9,410h2.4v8.1h-2.4L79.9,410z"
            />
            <path
                class="st3"
                d="M84.4,411.5c0,0,0-0.9,0-1.5h2.3l0.1,1.2c0.5-0.9,1.5-1.5,2.6-1.4c1.1-0.1,2.1,0.5,2.5,1.5
		c0.2,0.8,0.3,1.6,0.2,2.4v4.4h-2.5v-5c0-0.3,0-0.6-0.1-0.9c-0.2-0.4-0.7-0.7-1.2-0.7c-0.5,0-1,0.2-1.3,0.6
		c-0.2,0.4-0.3,0.8-0.3,1.2v4.8h-2.3V411.5z"
            />
            <path
                class="st3"
                d="M94.2,406.6h2.3v4.6c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2v4.9h-2.4v-4.9
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.1,0,0.2v4.9h-2.4V406.6z"
            />
            <path
                class="st3"
                d="M107.7,409.8c2.2-0.2,4,1.5,4.2,3.6c0,0.2,0,0.4,0,0.6c0.2,2.2-1.5,4.1-3.7,4.3c-0.2,0-0.4,0-0.6,0
		c-2.1,0.1-4-1.5-4.1-3.6c0-0.2,0-0.4,0-0.6C103.5,412.2,104.5,409.8,107.7,409.8z M107.7,416.8c1,0,1.7-0.6,1.7-2.8
		c0-1.1-0.2-2.6-1.8-2.6c-1.7,0-1.8,2-1.8,2.7C105.9,416,106.5,416.8,107.7,416.8L107.7,416.8z"
            />
            <path
                class="st3"
                d="M116,410v4.8c0,0.7,0,1.8,1.3,1.8c1.5,0,1.5-1.1,1.5-2.5V410h2.4v5.3c0,1.7,0,1.9,0,2.2c0,0.2,0,0.4,0.1,0.6
		H119l-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.9,0-1.8-0.4-2.4-1.1c-0.4-0.7-0.6-1.4-0.5-2.2v-5L116,410z"
            />
            <path
                class="st3"
                d="M128.8,406.6h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4c0-2.5,1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1L128.8,406.6z M127,416.7c0.6,0,1.2-0.4,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C125.3,415.5,125.8,416.7,127,416.7z"
            />
            <path
                class="st3"
                d="M59.7,397.6v-3.5l-9.4,2.6v2.9l-0.2,0.2l-4.9,2.6v23.1l9.5,5.1l9.6-5.1v-23.7L59.7,397.6z M62.7,402.1
		l-7.7,2.9l-3-4.5l6.6-2L62.7,402.1z M51.6,397.7l6.8-1.9v1.4l-6.8,2V397.7z M46.5,403.1l4.3-2.2l3.3,4.9v22.9l-7.6-4.1L46.5,403.1z
		 M63,424.6l-7.6,4.1v-22.5l7.6-2.8V424.6z"
            />
        </g>
        } @if (toggles.weight.shown) {
        <g
            class="system_item"
            id="gewicht"
            [ngStyle]="{
                transform: 'translateY(' + toggles.weight.offset + 'px)'
            }"
        >
            @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M387,466.4c-7.1-0.1-14,2.4-19.3,7L366,472l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C410.7,478.2,400.2,466.4,387,466.4z"
                />
                <path
                    class="st5"
                    d="M500,466.4c-7.1-0.1-14,2.4-19.3,7L479,472l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.7,0,23.3,11.8,23.4,12l0.8-0.7C523.7,478.2,513.2,466.4,500,466.4z"
                />
                <path
                    class="st5"
                    d="M611,466.4c-7.1-0.1-14,2.4-19.3,7L590,472l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C634.7,478.2,624.2,466.4,611,466.4z"
                />
                <path
                    class="st5"
                    d="M724,466.4c-7.1-0.1-14,2.4-19.3,7L703,472l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C747.7,478.2,737.2,466.4,724,466.4z"
                />
                <path
                    class="st5"
                    d="M834,466.4c-7.1-0.1-14,2.4-19.3,7L813,472l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C857.7,478.2,847.2,466.4,834,466.4z"
                />
                <path
                    class="st5"
                    d="M945,466.4c-7.1-0.1-14,2.4-19.3,7L924,472l-2.8,7.2l6.7-3.7l-1.5-1.3c5.2-4.4,11.8-6.7,18.5-6.6
			c12.8,0,23.3,11.8,23.4,12l0.8-0.7C968.7,478.2,958.2,466.4,945,466.4z"
                />
            </g>
            } @if (showJumps) {
            <g>
                <path
                    class="st5"
                    d="M411.2,525.9l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L411.2,525.9z"
                />
                <path
                    class="st5"
                    d="M524.2,525.9l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L524.2,525.9z"
                />
                <path
                    class="st5"
                    d="M635.2,525.9l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L635.2,525.9z"
                />
                <path
                    class="st5"
                    d="M748.2,525.9l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L748.2,525.9z"
                />
                <path
                    class="st5"
                    d="M858.2,525.9l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L858.2,525.9z"
                />
                <path
                    class="st5"
                    d="M969.2,525.9l-6.7,3.7l1.2,1.1c-5.1,4.3-11.5,6.7-18.2,6.8h-0.4c-12.6,0-23.1-11.4-23.2-11.5l-0.8,0.7
			c0.4,0.5,11,11.8,24,11.8h0.5c7,0,13.7-2.6,19-7.1l1.9,1.7L969.2,525.9z"
                />
            </g>
            }
            <g>
                <path
                    class="st12"
                    d="M636.4,525.9c-2.1,0-2.2-2.1-2.2-2.6v-41.1c0-2.5,2-2.5,2.2-2.5h63.8c2.1,0,2.2,2.1,2.2,2.6v41.1
			c0,2.4-1.9,2.5-2.2,2.5H636.4z"
                />
                <path
                    class="st8"
                    d="M700.1,480.5c1.1,0,1.3,1.1,1.3,1.7v41.1c0,1.1-0.5,1.6-1.3,1.7h-63.8c-1.2,0-1.3-1.1-1.4-1.7v-41.1
			c0-1.1,0.5-1.6,1.4-1.7H700.1 M700.1,478.8h-63.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1
			C703.2,482.2,703.2,478.8,700.1,478.8L700.1,478.8z"
                />
            </g>
            <path
                class="st0"
                d="M672.2,500.5c-0.1,0.7-0.1,1.3-0.1,2v6c0,3-2.5,3.3-4,3.3c-1.2,0-3.4-0.2-3.6-2.6h2.3c0,0.2,0.1,1.1,1.4,1.1
		c0.7,0.1,1.3-0.4,1.5-1.1c0.1-0.6,0.1-1.3,0.1-1.9c-0.5,0.7-1.3,1.1-2.2,1.1c-2.3,0-3.4-2-3.4-4s1.1-4,3.5-4
		c0.9-0.1,1.7,0.3,2.2,1.1l0.1-1.1L672.2,500.5z M668.2,506.8c1.7,0,1.7-2,1.7-2.3c0-0.9-0.2-2.5-1.6-2.5c-0.9,0-1.6,0.7-1.6,2.4
		C666.6,504.8,666.6,506.8,668.2,506.8L668.2,506.8z"
            />
            <path
                class="st13"
                d="M411.5,478.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4
		H411.5z"
            />
            <path
                class="st0"
                d="M434.7,497h2.4v4.5c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2v4.9H440v-4.8
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.2,0,0.2v4.9h-2.4V497z"
            />
            <path
                class="st0"
                d="M452.1,500.5c-0.1,0.7-0.1,1.3-0.1,2v6c0,3-2.5,3.3-4,3.3c-1.1,0-3.4-0.2-3.6-2.6h2.3c0,0.2,0.1,1.1,1.4,1.1
		c0.7,0.1,1.3-0.4,1.5-1.1c0.1-0.6,0.1-1.3,0.1-1.9c-0.5,0.7-1.3,1.1-2.2,1.1c-2.3,0-3.4-2-3.4-4s1.1-4,3.5-4
		c0.9-0.1,1.8,0.4,2.3,1.2l0.1-1.1H452.1z M448,506.8c1.7,0,1.7-2,1.7-2.3c0-0.9-0.2-2.5-1.6-2.5c-0.9,0-1.6,0.7-1.6,2.4
		C446.4,504.8,446.4,506.8,448,506.8L448,506.8z"
            />
            <path
                class="st12"
                d="M299.5,478.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4
		H299.5z"
            />
            <path
                class="st0"
                d="M323.4,497h2.3v6.8l2.4-3.4h2.7l-2.8,3.5l3,4.6h-2.8l-2.5-4.4v4.4h-2.4L323.4,497z"
            />
            <path
                class="st0"
                d="M339.4,500.5c-0.1,0.7-0.1,1.3-0.1,2v6c0,3-2.5,3.3-4,3.3c-1.2,0-3.4-0.2-3.6-2.6h2.3c0,0.2,0.1,1.1,1.4,1.1
		c0.7,0.1,1.3-0.4,1.5-1.1c0.1-0.6,0.1-1.3,0.1-1.9c-0.5,0.7-1.3,1.1-2.2,1.1c-2.3,0-3.4-2-3.4-4s1.1-4,3.5-4
		c0.9-0.1,1.8,0.4,2.3,1.2l0.1-1.1H339.4z M335.3,506.8c1.7,0,1.7-2,1.7-2.3c0-0.9-0.2-2.5-1.6-2.5c-0.9,0-1.6,0.7-1.6,2.4
		C333.7,504.8,333.7,506.8,335.3,506.8L335.3,506.8z"
            />
            <path
                class="st13"
                d="M747,478.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4H747z"
            />
            <path
                class="st0"
                d="M775.7,497h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.4l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4c0-2.7,1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1V497z M773.9,507.2c0.6,0,1.2-0.4,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C772.3,506,772.7,507.2,773.9,507.2L773.9,507.2z"
            />
            <path
                class="st0"
                d="M787.8,500.5c-0.1,0.7-0.1,1.3-0.1,2v6c0,3-2.5,3.3-4,3.3c-1.2,0-3.4-0.2-3.5-2.6h2.3c0,0.2,0.1,1.1,1.4,1.1
		c0.7,0.1,1.3-0.4,1.5-1.1c0.1-0.6,0.1-1.3,0.1-1.9c-0.5,0.7-1.3,1.1-2.2,1.1c-2.3,0-3.4-2-3.4-4s1.1-4,3.5-4
		c0.9-0.1,1.8,0.4,2.3,1.2l0.1-1.1H787.8z M783.7,506.8c1.7,0,1.7-2,1.7-2.3c0-0.9-0.2-2.5-1.6-2.5c-0.9,0-1.6,0.7-1.6,2.4
		C782.2,504.8,782.2,506.8,783.7,506.8z"
            />
            <path
                class="st13"
                d="M524.4,478.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4
		H524.4z"
            />
            <path
                class="st0"
                d="M548.7,497h2.4v10.2c0,0.5,0,1,0.1,1.3h-2.5l-0.1-1.2c-0.2,0.4-0.5,0.7-0.8,0.9c-0.5,0.3-1,0.4-1.6,0.4
		c-2.2,0-3.4-1.5-3.4-4c0-2.7,1.5-4.3,3.6-4.3c0.9-0.1,1.8,0.4,2.3,1.1L548.7,497z M546.9,507.2c0.6,0,1.2-0.4,1.5-0.9
		c0.3-0.6,0.4-1.2,0.4-1.9c0-1.6-0.7-2.5-1.8-2.5c-1.6,0-1.8,1.9-1.8,2.7C545.3,506,545.7,507.2,546.9,507.2L546.9,507.2z"
            />
            <path
                class="st0"
                d="M558,508.5c-0.1-0.4-0.1-0.7-0.1-1.1c-0.5,0.8-1.4,1.3-2.4,1.3c-0.7,0.1-1.4-0.2-2-0.6
		c-0.5-0.5-0.7-1.1-0.7-1.8c0-1.1,0.7-2.1,1.7-2.5c1-0.4,2.1-0.5,3.2-0.5c0-0.4,0-0.7-0.1-1.1c-0.3-0.6-0.9-0.8-1.5-0.6
		c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.5-0.2,0.7h-2.3c0-0.7,0.3-1.5,0.9-1.9c0.7-0.5,1.6-0.7,2.4-0.7c1.1-0.1,2.1,0.3,2.9,1
		c0.4,0.6,0.6,1.3,0.6,2v3.3c0,0.7,0.1,1.3,0.2,2H558z M555.1,506.1c0,0.6,0.5,1.1,1.1,1.2c0,0,0.1,0,0.1,0c0.4,0,0.7-0.2,1-0.5
		c0.4-0.6,0.5-1.3,0.5-2C556.1,504.6,555.1,505.1,555.1,506.1L555.1,506.1z"
            />
            <path
                class="st0"
                d="M569.7,500.5c-0.1,0.7-0.1,1.3-0.1,2v6c0,3-2.5,3.3-4,3.3c-1.2,0-3.4-0.2-3.6-2.6h2.3c0,0.2,0.1,1.1,1.4,1.1
		c0.7,0.1,1.3-0.4,1.5-1.1c0.1-0.6,0.1-1.3,0.1-1.9c-0.5,0.7-1.3,1.1-2.2,1.1c-2.3,0-3.4-2-3.4-4s1.1-4,3.5-4
		c0.9-0.1,1.8,0.4,2.3,1.2l0.1-1.1H569.7z M565.6,506.8c1.7,0,1.7-2,1.7-2.3c0-0.9-0.2-2.5-1.6-2.5c-0.9,0-1.6,0.7-1.6,2.4
		C564,504.8,564,506.8,565.6,506.8L565.6,506.8z"
            />
            <path
                class="st13"
                d="M857.4,478.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4
		H857.4z"
            />
            <path
                class="st0"
                d="M886,503.4c0-0.3-0.1-1.5-1-1.5c-1.1,0-1.2,1.7-1.2,2.6c-0.1,0.9,0.2,1.7,0.6,2.5c0.2,0.2,0.4,0.3,0.6,0.3
		c0.2,0,1-0.1,1.1-1.5h2.3c0,0.9-0.3,1.8-1,2.4c-0.6,0.5-1.5,0.8-2.3,0.8c-1,0.1-2-0.3-2.8-1.1c-0.7-0.9-1.1-2-1-3.2
		c0-3.7,2.7-4.2,3.8-4.2c1.6-0.2,3.1,1,3.3,2.7c0,0.1,0,0.2,0,0.3L886,503.4z"
            />
            <path
                class="st0"
                d="M897.4,500.5c-0.1,0.7-0.1,1.3-0.1,2v6c0,3-2.5,3.3-4,3.3c-1.2,0-3.4-0.2-3.5-2.6h2.3c0,0.2,0.2,1.1,1.4,1.1
		c0.7,0.1,1.3-0.4,1.5-1.1c0.1-0.6,0.1-1.3,0.1-1.9c-0.5,0.7-1.3,1.1-2.2,1.1c-2.3,0-3.4-2-3.4-4s1.1-4,3.5-4
		c0.9-0.1,1.8,0.4,2.2,1.2l0.1-1.1H897.4z M893.3,506.8c1.7,0,1.7-2,1.7-2.3c0-0.9-0.2-2.5-1.6-2.5c-0.9,0-1.6,0.7-1.6,2.4
		C891.7,504.8,891.7,506.8,893.3,506.8L893.3,506.8z"
            />
            <path
                class="st12"
                d="M968.5,478.8c0,0-3.1,0-3.1,3.4v41.1c0,0,0,3.4,3.1,3.4h63.8c0,0,3.1,0,3.1-3.4v-41.1c0,0,0-3.4-3.1-3.4
		H968.5z"
            />
            <path
                class="st0"
                d="M989.6,502.4c0-0.5,0-1-0.1-1.5h2.2l0.1,1c0.5-0.8,1.4-1.2,2.4-1.2c1-0.1,2,0.5,2.4,1.5
		c0.5-0.9,1.4-1.5,2.5-1.4c1-0.1,1.9,0.4,2.3,1.2c0.3,0.7,0.5,1.5,0.4,2.3v4.4h-2.3v-4.5c0-0.8-0.1-1.8-1.3-1.8
		c-1.4,0-1.4,1.3-1.4,2.4v3.9h-2.3v-4.6c0-0.6,0-1.7-1.3-1.7c-1.4,0-1.4,1.2-1.4,1.8v4.5h-2.3L989.6,502.4z"
            />
            <path
                class="st0"
                d="M1011.3,501c-0.1,0.6-0.1,1.3-0.1,1.9v5.7c0,2.8-2.4,3.1-3.9,3.1c-1.1,0-3.3-0.1-3.4-2.5h2.2
		c0,0.2,0.1,1.1,1.3,1.1c0.7,0.1,1.3-0.4,1.4-1c0.1-0.6,0.1-1.2,0.1-1.8c-0.5,0.7-1.3,1.1-2.1,1.1c-2.2,0-3.3-1.9-3.3-3.8
		s1.1-3.8,3.3-3.8c0.9-0.1,1.7,0.4,2.2,1.1l0.1-1L1011.3,501z M1007.4,507c1.6,0,1.6-1.9,1.6-2.2c0-0.9-0.2-2.4-1.5-2.4
		c-0.9,0-1.6,0.7-1.6,2.3C1005.9,505.1,1005.9,507,1007.4,507z"
            />
            @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M378.4,480.8h1.7v1.7h-1.7V480.8z M378.4,486.6h1.7v1.8h-1.7V486.6z"
                />
                <path
                    class="st6"
                    d="M385.4,480.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L385.4,480.6z"
                />
                <path
                    class="st6"
                    d="M393,478.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C389.5,482.8,389.7,478.8,393,478.8z M393,488.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C391,486.5,391.4,488.4,393,488.4L393,488.4z"
                />
                <path
                    class="st6"
                    d="M491.4,480.8h1.7v1.7h-1.7V480.8z M491.4,486.6h1.7v1.8h-1.7V486.6z"
                />
                <path
                    class="st6"
                    d="M498.4,480.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L498.4,480.6z"
                />
                <path
                    class="st6"
                    d="M506,478.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C502.5,482.8,502.7,478.8,506,478.8z M506,488.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C504,486.5,504.4,488.4,506,488.4L506,488.4z"
                />
                <path
                    class="st6"
                    d="M602.4,480.8h1.7v1.7h-1.7V480.8z M602.4,486.6h1.7v1.8h-1.7V486.6z"
                />
                <path
                    class="st6"
                    d="M609.4,480.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L609.4,480.6z"
                />
                <path
                    class="st6"
                    d="M617,478.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C613.5,482.8,613.7,478.8,617,478.8z M617,488.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C615,486.5,615.4,488.4,617,488.4L617,488.4z"
                />
                <path
                    class="st6"
                    d="M715.4,480.8h1.7v1.7h-1.7V480.8z M715.4,486.6h1.7v1.8h-1.7V486.6z"
                />
                <path
                    class="st6"
                    d="M722.4,480.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L722.4,480.6z"
                />
                <path
                    class="st6"
                    d="M730,478.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C726.5,482.8,726.7,478.8,730,478.8z M730,488.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C728,486.5,728.4,488.4,730,488.4L730,488.4z"
                />
                <path
                    class="st6"
                    d="M825.4,480.8h1.7v1.7h-1.7V480.8z M825.4,486.6h1.7v1.8h-1.7V486.6z"
                />
                <path
                    class="st6"
                    d="M832.4,480.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L832.4,480.6z"
                />
                <path
                    class="st6"
                    d="M840,478.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C836.5,482.8,836.7,478.8,840,478.8z M840,488.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C838,486.5,838.4,488.4,840,488.4L840,488.4z"
                />
                <path
                    class="st6"
                    d="M936.4,480.8h1.7v1.7h-1.7V480.8z M936.4,486.6h1.7v1.8h-1.7V486.6z"
                />
                <path
                    class="st6"
                    d="M943.4,480.6c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L943.4,480.6z"
                />
                <path
                    class="st6"
                    d="M951,478.8c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2c-0.2-0.2-0.4-0.5-0.5-0.7
			c-0.5-1.1-0.7-2.3-0.7-3.6C947.5,482.8,947.7,478.8,951,478.8z M951,488.4c1.7,0,2-2.3,2-4.1c0-2.5-0.4-4.2-2-4.2
			c-1.8,0-2,2.4-2,4.2C949,486.5,949.4,488.4,951,488.4L951,488.4z"
                />
            </g>
            } @if (showJumps) {
            <g>
                <path
                    class="st6"
                    d="M378.6,522.7l-2.8-2.8l0.9-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L378.6,522.7z"
                />
                <path
                    class="st6"
                    d="M387.9,517.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L387.9,517.7z"
                />
                <path
                    class="st6"
                    d="M395.5,515.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C392,519.9,392.2,515.9,395.5,515.9z M395.5,525.4c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C393.4,523.6,393.9,525.5,395.5,525.4L395.5,525.4z"
                />
                <path
                    class="st6"
                    d="M491.6,522.7l-2.8-2.8l0.9-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L491.6,522.7z"
                />
                <path
                    class="st6"
                    d="M500.9,517.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L500.9,517.7z"
                />
                <path
                    class="st6"
                    d="M508.5,515.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C505,519.9,505.2,515.9,508.5,515.9z M508.5,525.4c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C506.4,523.6,506.9,525.5,508.5,525.4L508.5,525.4z"
                />
                <path
                    class="st6"
                    d="M602.6,522.7l-2.8-2.8l0.9-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.9,0.9l-2.8-2.8l-2.8,2.8
			l-0.8-0.9L602.6,522.7z"
                />
                <path
                    class="st6"
                    d="M611.9,517.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4V517.7z"
                />
                <path
                    class="st6"
                    d="M619.5,515.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C616,519.9,616.2,515.9,619.5,515.9z M619.5,525.4c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C617.4,523.6,617.9,525.5,619.5,525.4L619.5,525.4z"
                />
                <path
                    class="st6"
                    d="M715.6,522.7l-2.8-2.8l0.8-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L715.6,522.7z"
                />
                <path
                    class="st6"
                    d="M724.9,517.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L724.9,517.7z"
                />
                <path
                    class="st6"
                    d="M732.5,515.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C729,519.9,729.2,515.9,732.5,515.9z M732.5,525.4c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C730.4,523.6,730.9,525.5,732.5,525.4L732.5,525.4z"
                />
                <path
                    class="st6"
                    d="M825.6,522.7l-2.8-2.8l0.8-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L825.6,522.7z"
                />
                <path
                    class="st6"
                    d="M834.9,517.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L834.9,517.7z"
                />
                <path
                    class="st6"
                    d="M842.5,515.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C839,519.9,839.2,515.9,842.5,515.9z M842.5,525.4c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C840.4,523.6,840.9,525.5,842.5,525.4L842.5,525.4z"
                />
                <path
                    class="st6"
                    d="M936.6,522.7l-2.8-2.8l0.8-0.8l2.8,2.8l2.8-2.8l0.9,0.8l-2.8,2.8l2.8,2.8l-0.8,0.9l-2.8-2.8l-2.8,2.8
			l-0.9-0.9L936.6,522.7z"
                />
                <path
                    class="st6"
                    d="M945.9,517.7c-0.7,0.6-1.6,1.1-2.4,1.5v-1.5c0.9-0.5,1.7-1,2.5-1.6h1.3v10.4h-1.4L945.9,517.7z"
                />
                <path
                    class="st6"
                    d="M953.5,515.9c3.1,0,3.5,3.3,3.5,5.3c0,2.5-0.5,3.8-1.4,4.7c-1.3,1.1-3.2,1.1-4.4-0.2
			c-0.2-0.2-0.4-0.5-0.5-0.7c-0.5-1.1-0.7-2.3-0.7-3.5C950,519.9,950.2,515.9,953.5,515.9z M953.5,525.4c1.7,0,2-2.3,2-4.1
			c0-2.5-0.4-4.2-2-4.2c-1.8,0-2.1,2.4-2.1,4.2C951.4,523.6,951.9,525.5,953.5,525.4L953.5,525.4z"
                />
            </g>
            }
            <g>
                <path
                    class="st0"
                    d="M27.2,526.3c-3.4,0-3.5-2.6-3.5-2.9v-41.1c0-2.9,3.4-2.9,3.5-2.9h127c3.4,0,3.5,2.6,3.5,2.9v41.1
			c0,2.9-3.4,2.9-3.5,2.9h0H27.2z"
                />
                <path
                    class="st3"
                    d="M154.2,479.8c2.8,0,3,2,3,2.4v41.1c0,2.3-2.7,2.4-3,2.4h-127c-2.8,0-3-2-3-2.4v-41.1c0-2.3,2.7-2.4,3-2.4
			H154.2 M154.2,478.8h-127c0,0-4,0-4,3.4v41.1c0,0,0,3.4,4,3.4h127c0,0,4,0,4-3.4v-41.1C158.2,482.2,158.2,478.8,154.2,478.8
			L154.2,478.8z"
                />
            </g>
            <path
                class="st3"
                d="M90.6,500.6c-0.1,0.7-0.1,1.3-0.1,2v6c0,3-2.5,3.3-4,3.3c-1.2,0-3.4-0.2-3.6-2.6h2.3c0,0.2,0.1,1.1,1.4,1.1
		c0.7,0.1,1.3-0.4,1.5-1.1c0.1-0.6,0.1-1.3,0.1-1.9c-0.5,0.7-1.3,1.1-2.2,1.1c-2.3,0-3.4-2-3.4-4s1.1-4,3.4-4
		c0.9-0.1,1.7,0.3,2.2,1.1l0.1-1.1L90.6,500.6z M86.5,506.8c1.7,0,1.7-2,1.7-2.3c0-0.9-0.2-2.5-1.6-2.5c-0.9,0-1.6,0.7-1.6,2.4
		C84.9,504.8,84.9,506.8,86.5,506.8L86.5,506.8z"
            />
            <path
                class="st3"
                d="M94.3,505.1c0,0.5,0,2.2,1.7,2.2c0.7,0.1,1.3-0.4,1.4-1.1h2.2c0,0.7-0.3,1.3-0.8,1.8c-0.8,0.7-1.8,1.1-2.8,1
		c-1,0.1-2.1-0.3-2.8-1c-1.6-2.2-1.3-5.2,0.6-7c0.7-0.4,1.5-0.7,2.3-0.7c1.4,0,2.7,0.7,3.3,2c0.4,0.9,0.6,2,0.5,3L94.3,505.1z
		 M97.3,503.6c0-0.4,0-1.8-1.4-1.8c-1,0-1.5,0.9-1.5,1.8H97.3z"
            />
            <path
                class="st3"
                d="M102.8,500.5l1.5,6.1l1.7-6.1h2.6l1.7,6.1l1.6-6.1h2.3l-2.8,8.1h-2.6l-1.7-6l-1.7,6h-2.6l-2.6-8.1L102.8,500.5
		z"
            />
            <path
                class="st3"
                d="M115.4,497h2.5v2.1h-2.5V497z M115.5,500.5h2.4v8.1h-2.4V500.5z"
            />
            <path
                class="st3"
                d="M124.2,503.4c0-0.3-0.1-1.5-1-1.5c-1.1,0-1.2,1.7-1.2,2.6c0,0.9,0.2,1.7,0.6,2.5c0.2,0.2,0.4,0.3,0.6,0.3
		c0.2,0,1-0.1,1.1-1.6h2.3c0,0.9-0.3,1.8-1,2.4c-0.6,0.5-1.5,0.8-2.3,0.8c-1,0.1-2-0.3-2.8-1.1c-0.7-0.9-1.1-2-1-3.2
		c0-3.7,2.7-4.2,3.8-4.2c1.6-0.2,3.1,1,3.3,2.7c0,0.1,0,0.2,0,0.3L124.2,503.4z"
            />
            <path
                class="st3"
                d="M127.7,497h2.3v4.5c0.5-0.8,1.4-1.3,2.3-1.2c0.9,0,1.8,0.4,2.4,1.1c0.4,0.7,0.6,1.4,0.5,2.2v4.9h-2.4v-4.8
		c0-0.5,0-1.8-1.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.2,0,0.2v4.9h-2.4L127.7,497z"
            />
            <path
                class="st3"
                d="M142.2,508.5c-0.6,0.2-1.2,0.3-1.8,0.3c-2.4,0-2.4-1.5-2.4-2.2v-4.4h-1.6v-1.6h1.6V499l2.4-0.9v2.5h1.9v1.6
		h-1.9v3.7c0,0.7,0,1.2,1.1,1.2c0.3,0,0.5,0,0.8,0L142.2,508.5z"
            />
            <path
                class="st3"
                d="M69.9,501.4h-3.3c0-0.9-0.7-1.7-1.6-1.7c0,0,0,0,0,0h-1.7c-0.2,0-0.4,0-0.5,0.1v-1.6c0,0,0-1.9-1.7-1.9h-1.7
		c-0.9,0-1.7,0.8-1.7,1.7c0,0,0,0.1,0,0.1v3.2H47v-3.2c0,0,0-1.9-1.7-1.9h-1.7c-0.9,0-1.7,0.8-1.7,1.7c0,0,0,0.1,0,0.1v1.6
		c-0.2-0.1-0.4-0.1-0.5-0.1h-1.6c-0.9,0-1.6,0.8-1.6,1.7h-3.3v4.9h3.2v1.3c0,0,0,1.9,1.7,1.9h1.7c0.2,0,0.4-0.1,0.5-0.1v1.6
		c0,0,0,1.9,1.7,1.9h1.7c0.9,0,1.7-0.8,1.7-1.7c0,0,0-0.1,0-0.1v-4.6h10.8v4.6c0,0,0,1.9,1.7,1.9h1.7c0.9,0,1.7-0.8,1.7-1.7
		c0,0,0-0.1,0-0.1v-1.6c0.2,0.1,0.4,0.1,0.5,0.1H65c0.9,0,1.7-0.8,1.6-1.7c0,0,0-0.1,0-0.1v-1.3h3.3V501.4z M36.4,504.8v-1.9h1.8
		v1.9H36.4z M47,504.8v-1.9h10.8v1.9H47z M68.4,504.8h-1.8v-1.9h1.8V504.8z"
            />
            <g>
                <path
                    class="st0"
                    d="M179.4,525.9c-2.5,0-2.5-2.8-2.5-2.9v-41.1c0-2.9,2.4-2.9,2.5-2.9h95.9c2.5,0,2.5,2.8,2.5,2.9V523
			c0,2.8-2.3,2.9-2.5,2.9h0H179.4z"
                />
                <path
                    class="st12"
                    d="M275.2,479.4c1.9,0,2,2,2,2.4V523c0,2.2-1.6,2.4-2,2.4h-95.9c-1.9,0-2-2-2-2.4v-41.1c0-2.2,1.6-2.4,2-2.4
			H275.2 M275.2,478.4h-95.9c0,0-3,0-3,3.4V523c0,0,0,3.4,3,3.4h95.9c0,0,3,0,3-3.4v-41.1C278.3,481.9,278.3,478.4,275.2,478.4
			L275.2,478.4z"
                />
            </g>
            <g>
                <g>
                    <path
                        class="st12"
                        d="M211.3,492.6h-20.5c-1.7,0-3.1,1.4-3.1,3.1l-2.7,19.4c0,1.7,1.4,3.1,3.1,3.1h25.7c1.7,0,3.1-1.4,3.1-3.1
				l-2.4-19.4C214.5,494,213.1,492.6,211.3,492.6z"
                    />
                    <circle class="st14" cx="200.9" cy="491.9" r="5.4" />
                </g>
                <g>
                    <path
                        class="st0"
                        d="M196,512.4c-0.5,0.1-1,0.2-1.5,0.2c-1.9,0-1.9-1.2-1.9-1.7v-3.5h-1.2v-1.2h1.2v-1.3l1.9-0.7v2h1.5v1.2h-1.5
				v2.9c0,0.6,0,1,0.8,1c0.2,0,0.4,0,0.6,0L196,512.4z"
                    />
                    <path
                        class="st0"
                        d="M200.2,505.8c1.7-0.1,3.2,1.1,3.3,2.9c0,0.2,0,0.3,0,0.5c0.1,1.7-1.2,3.3-2.9,3.4c-0.2,0-0.3,0-0.5,0
				c-1.7,0.1-3.2-1.2-3.3-2.9c0-0.1,0-0.3,0-0.4C196.9,507.7,197.7,505.8,200.2,505.8z M200.2,511.3c0.8,0,1.4-0.5,1.4-2.2
				c0-0.8-0.2-2-1.4-2c-1.4,0-1.4,1.6-1.4,2.2C198.8,510.7,199.3,511.3,200.2,511.3L200.2,511.3z"
                    />
                    <path
                        class="st0"
                        d="M204.4,507.2c0,0,0-0.7,0-1.2h1.8l0.1,1c0.4-0.7,1.2-1.2,2.1-1.1c0.8-0.1,1.6,0.4,2,1.2
				c0.2,0.6,0.2,1.3,0.2,1.9v3.5h-2v-4c0-0.2,0-0.5-0.1-0.7c-0.2-0.3-0.5-0.6-0.9-0.5c-0.4,0-0.8,0.2-1,0.5c-0.2,0.3-0.2,0.6-0.2,1
				v3.7h-1.9V507.2z"
                    />
                </g>
                <g>
                    <path
                        class="st12"
                        d="M257,503.3h1.8v5.4l1.9-2.7h2.1l-2.2,2.8l2.3,3.6h-2.2l-2-3.5v3.5H257L257,503.3z"
                    />
                    <path
                        class="st12"
                        d="M269.6,506.1c-0.1,0.5-0.1,1.1-0.1,1.6v4.7c0,2.4-2,2.6-3.2,2.6c-0.9,0-2.7-0.1-2.8-2h1.8
				c0,0.2,0.1,0.9,1.1,0.9c0.5,0.1,1-0.3,1.2-0.8c0.1-0.5,0.1-1,0.1-1.5c-0.4,0.6-1,0.9-1.7,0.9c-1.8,0-2.7-1.6-2.7-3.2
				s0.9-3.2,2.7-3.2c0.7-0.1,1.4,0.3,1.8,0.9l0.1-0.8H269.6z M266.4,511.1c1.3,0,1.3-1.6,1.3-1.8c0-0.7-0.1-1.9-1.3-1.9
				c-0.7,0-1.3,0.5-1.3,1.9C265.2,509.5,265.2,511.1,266.4,511.1L266.4,511.1z"
                    />
                    <path
                        class="st15"
                        d="M231.1,505.1c-0.6,0.5-1.2,0.9-1.9,1.2v-1.2c0.7-0.4,1.4-0.8,2-1.3h1.1v8.2h-1.1L231.1,505.1z"
                    />
                    <path
                        class="st15"
                        d="M237.1,503.6c2.5,0,2.7,2.6,2.7,4.2c0,1.9-0.4,3-1.1,3.7c-0.4,0.4-1,0.6-1.6,0.6c-0.9,0-1.8-0.5-2.2-1.4
				c-0.4-0.9-0.6-1.8-0.5-2.8C234.3,506.8,234.5,503.6,237.1,503.6z M237.1,511.2c1.4,0,1.6-1.8,1.6-3.3c0-2-0.3-3.3-1.6-3.3
				c-1.4,0-1.6,1.9-1.6,3.4C235.4,509.8,235.8,511.2,237.1,511.2L237.1,511.2z"
                    />
                    <path
                        class="st15"
                        d="M244.1,503.6c2.5,0,2.7,2.6,2.7,4.2c0,1.9-0.4,3-1.1,3.7c-0.4,0.4-1,0.6-1.6,0.6c-0.9,0-1.8-0.5-2.2-1.4
				c-0.4-0.9-0.6-1.8-0.5-2.8C241.4,506.8,241.5,503.6,244.1,503.6z M244.1,511.2c1.4,0,1.6-1.8,1.6-3.3c0-2-0.3-3.3-1.6-3.3
				c-1.4,0-1.6,1.9-1.6,3.4C242.6,509.8,242.9,511.2,244.1,511.2z"
                    />
                    <path
                        class="st15"
                        d="M251.2,503.6c2.5,0,2.7,2.6,2.7,4.2c0,1.9-0.4,3-1.1,3.7c-0.4,0.4-1,0.6-1.6,0.6c-0.9,0-1.8-0.5-2.2-1.4
				c-0.4-0.9-0.6-1.8-0.5-2.8C248.4,506.8,248.6,503.6,251.2,503.6z M251.2,511.2c1.4,0,1.6-1.8,1.6-3.3c0-2-0.3-3.3-1.6-3.3
				c-1.4,0-1.6,1.9-1.6,3.4C249.6,509.8,249.9,511.2,251.2,511.2z"
                    />
                </g>
                <g>
                    <rect
                        x="219.9"
                        y="506.6"
                        class="st12"
                        width="7"
                        height="1.5"
                    />
                    <rect
                        x="219.9"
                        y="509.7"
                        class="st12"
                        width="7"
                        height="1.5"
                    />
                </g>
            </g>
        </g>
        }
    </svg>
</ng-template>
